import { useState, useEffect, useRef, useContext } from "react";
import {
  Page,
  Navbar,
  BtnBlock,
  DialogBox,
  BtnSmall,
  BtnSmallDisabled,
  Loader,
  BtnSmallWhite,
  PopUp
} from "../components";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as ROUTES from "../constant/routes";
import { AuthContext } from "../context/auth";
import Book from "../assets/images/book.png";
import {
  addABookAddCategory,
  addABookAddPublication,
  addABookAddAuthor,
  addABookSearchCategory,
  addABookSearchPublication,
  addABookSearchAuthor,
  getOngoingConversion,
  wallet,
  addABookStepZero,
  addABookStepalpha,
  addABookStepFirst,
  addABookStepSecond,
  addABookStepThird,
  addABookStepFourth,
  getMyPublication,
  deleteDraftBook,
  getS3SessionToken
} from "../assets/Js/script";
import Timeout from "../helpers/Timeout";
import Addendums from "./add_Addendums";
import { ToastContainer, toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import FastAverageColor from "fast-average-color";
import CryptoJS from "crypto-js";
import { PDFDocument, StandardFonts } from "pdf-lib";
import encryptFile from "../helpers/encryptFile";

export default function AddNewBook() {
  const notify = (message) => toast(message);
  const Hoverref = useRef(null);
  const [modals, setModals] = useState({
    addNew: false,
    uploadByBook: false,
    addendums: false,
    waitPop: false,
    paymentSuccessful: false,
    draftDelete: false
  });
  const [deleteId, setDeleteId] = useState("");

  const [otps, setOtps] = useState(new Array(6).fill(""));
  const [filterSort, setFilterSort] = useState(false);
  const [filterData, setFilterData] = useState("1");
  const [sortDropdown, setSortDropDown] = useState([1, 2, 3, 4, 5]);
  const [isLoading, setIsLoading] = useState(true);
  const [newBookAdded, setNewBookAdded] = useState(false);
  const [cancelNewBook, setCancelNewBook] = useState(false);
  const [showUploadBook, setShowUploadBook] = useState(true);
  const [backgroundColor, setBackgroundColors] = useState("");

  const [hover, setHover] = useState({
    conversionCharges: false,
    hostingCharges: false
  });

  const { user, notifySound, setNotifySound } = useContext(AuthContext);

  useEffect(() => {
    window.addEventListener("click", handleClosePop);
    function handleClosePop() {
      setHover((prev) => ({
        ...prev,
        conversionCharges: false,
        hostingCharges: false
      }));
    }
    return () => {
      window.removeEventListener("click", handleClosePop);
    };
  }, [hover]);

  async function deletedraft() {
    console.log(deleteId, "deleteId");
    const { response, error } = await deleteDraftBook(deleteId);
    if (!response) {
      setBooks((prevState) => [
        ...prevState.filter((item) => item.id !== deleteId)
      ]);
      setModals((prev) => ({ ...prev, draftDelete: false }));
      notify("Draft has been deleted successfully!");
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }

  function changeData(data) {
    setFilterData(data);
    setFilterSort(false);
  }
  const navigate = useNavigate();
  const [amountToPay, setAmountToPay] = useState("");
  const [uploadByBook, setUploadByBook] = useState(true);
  const [miniLoader, setMiniLoader] = useState(false);
  const [parentId, setParentId] = useState(null);
  const [metaData, setMetaData] = useState({
    bookId: "",
    title: "",
    bookCover: [],
    ISBN: "",
    category: [],
    edition: "",
    authors: [],
    publications: [],
    price: null,
    validity: null,
    shortDescription: "",
    pageNoStartsAt: 1,
    longDescription: "",
    numberOfPages: null,
    customKeyName: null,
    customValueName: null,
    printedBookCost: null,
    validity: "",
    eBookPrice: 0,
    hardbookPrice: 0,
    noOfPages: 0,
    isPrintedBookAvailable: false,
    additionalField: {
      name: "",
      value: "",
      enable: false
    }
  });
  const [category, setCategory] = useState({ id: null, bookCategoryName: "" });
  const [author, setAuthor] = useState({ id: null, bookAuthorName: "" });
  const [publication, setPublication] = useState({
    id: null,
    bookPublicationName: ""
  });
  const [showCategorySuggestion, setShowCategorySuggestion] = useState(false);
  const [showAuthorSuggestion, setShowAuthorSuggestion] = useState(false);
  const [showPublicationSuggestion, setShowPublicationSuggestion] =
    useState(false);
  const [categorySuggestionArr, setCategorySuggestionArr] = useState([]);
  const [authorSuggestionArr, setAuthorSuggestionArr] = useState([]);
  const [publicationSuggestionArr, setPublicationSuggestionArr] = useState([]);

  const [books, setBooks] = useState([]);

  function handleUploadType({ target }) {
    setUploadByBook(target.name === "radio-1" ? true : false);
  }

  // stepper

  const [currentStep, setCurrentStep] = useState(1);
  const [uploading, setUploading] = useState(false);
  const [inSufficientBalance, setInSufficientBalance] = useState(false);
  const [paid, setPaid] = useState(false);
  const [renderedStep, setRenderedStep] = useState(null);
  const [uploadedBookData, setUploadedBookData] = useState(null);
  const [resend, setResend] = useState(false);
  const [walletDetails, setWalletDetails] = useState(null);

  const handleSessionTokens = async () => {
    // const { response, error } = await getS3SessionToken();
    // console.log(response, error, "s3 token");
  };

  async function handleStepFirst(e) {
    setUploading(true);
    e.preventDefault();
    try {
      const inputFile = e.target.files;
      const encryptedFile = await encryptFile(inputFile[0]);
      const file = [encryptedFile];
      // const file = e.target.files;
      // console.log(file, "fffff");
      const { response, error } = await addABookStepZero();
      console.log(response, "resssss");
      if (!response || response.status !== "success") {
        notify(
          response?.message || error?.message || "Failed to get upload URL. Please try again."
        );
        setUploading(false);
        return;
      }

      const { responses, errors } = await addABookStepalpha(
        file[0],
        response.data.url
      );
      console.log(errors, "reeeee");
      if (!responses || errors) {
        notify(
          errors?.message || "Failed to upload file to S3. Please try again."
        );
        setUploading(false);
        return;
      }

      const { responsed, error: uploadError } = await addABookStepFirst(
        response.data.key,
        inputFile[0].name
      );
      console.log(uploadError, "eeeee");
      
      if (!responsed || uploadError) {
        notify(
          uploadError?.message || responsed?.message || "Failed to process book upload. Please try again."
        );
        setUploading(false);
        return;
      }

      if (responsed.status === "success") {
        setUploadedBookData({ ...responsed.data.uploadedBook });
        setCurrentStep(2);
        setUploading(false);
        setMetaData((prevState) => ({
          ...prevState,
          noOfPages: responsed.data.uploadedBook.countOfPages,
          bookId: responsed.data.uploadedBook.id,
          publicationId: responsed.data.uploadedBook.publicationId,
          hostingCharge: responsed.data.uploadedBook.hostingCharge,
          conversionCharge: responsed.data.uploadedBook.conversionCharge
        }));
      } else {
        notify(
          responsed?.message || "Something went wrong"
        );
        setUploading(false);
        setMiniLoader(false);
      }
    } catch (err) {
      console.error("Error in handleStepFirst:", err);
      notify("An unexpected error occurred. Please try again.");
      setUploading(false);
      setMiniLoader(false);
    }
  }

  async function handleStepSecond(e) {
    // e.preventDefault();
    setMiniLoader(true);
    setOtps([...otps.map((v) => "")]);
    setModals((prevState) => ({
      ...prevState,
      addNew: false,
      uploadByBook: uploadByBook ? true : false
    }));

    const { response, error } = await addABookStepSecond({
      bookId: uploadedBookData.id,
      validity: filterData,
      totalCredits:
        (parseFloat(uploadedBookData.conversionCharge) +
          parseInt(filterData) * parseFloat(uploadedBookData.hostingCharge)) *
        1
    });
    console.log(error, "errrrr");
    if (
      response.status === "success" ||
      response?.message == "SMS OTP Failed! Please check OTP on your email."
    ) {
      setMiniLoader(false);
      setPaid(true);
      setOtps([...otps.map((v) => "")]);
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
      setMiniLoader(false);
    }
  }

  async function handleAcceptCharges() {
    setMiniLoader(true);
    setOtps([...otps.map((v) => "")]);
    const { response, error } = await wallet();
    if (response.status === "success") {
      setMiniLoader(false);
      setWalletDetails({ ...response.data });
      response.data.myCredits.credits <
        parseFloat(uploadedBookData.conversionCharge) +
          parseInt(uploadedBookData.hostingCharge) * parseInt(filterData) &&
        setInSufficientBalance(true);

      setAmountToPay(
        (
          parseFloat(uploadedBookData.conversionCharge) +
          parseInt(filterData) * parseFloat(uploadedBookData.hostingCharge)
        ).toFixed(2)
      );
      setCurrentStep(3);
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
      setMiniLoader(false);
    }
  }

  async function handleStepThird(e) {
    setMiniLoader(true);
    const { response, error } = await addABookStepThird(otps.join(""));
    if (response.status === "success") {
      setMiniLoader(false);
      setModals((prev) => ({
        ...prev,
        uploadByBook: false,
        paymentSuccessful: true
      }));
      setCurrentStep(1);
      setPaid(false);
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
      setMiniLoader(false);
      setOtps([...otps.map((v) => "")]);
    }
  }

  function handleChnges(data, index) {
    if (isNaN(data.value)) {
      return false;
    }
    setOtps([...otps.map((d, idx) => (idx === index ? data.value : d))]);

    // for AutoFocu

    if (data.nextSibling && data.value) {
      data.nextSibling.focus();
    }
  }

  useEffect(() => {
    (async () => {
      const { response, error } = await addABookSearchCategory(
        category.bookCategoryName
      );
      if (response.status === "success") {
        setCategorySuggestionArr([...response.data.categories]);
      }
    })();
    setShowCategorySuggestion(category.bookCategoryName.length > 0);
  }, [category]);

  useEffect(() => {
    (async () => {
      const { response, error } = await addABookSearchAuthor(
        author.bookAuthorName
      );

      if (response.status === "success") {
        setAuthorSuggestionArr([...response.data.authors]);
      }
    })();
    setShowAuthorSuggestion(author.bookAuthorName.length > 0);
  }, [author]);

  useEffect(() => {
    (async () => {
      const { response, error } = await addABookSearchPublication(
        publication.bookAuthorName
      );

      if (response.status === "success") {
        setPublicationSuggestionArr([...response.data.publications]);
      }
    })();
    setShowPublicationSuggestion(publication.bookPublicationName.length > 0);
  }, [publication]);

  async function PublicationDefaultValue(data) {
    const { response, error } = await addABookAddPublication(data);

    if (response.status === "success") {
      setMetaData((prevState) => ({
        ...prevState,
        publications: [
          {
            id: response.data.publication.id,
            bookPublicationName: response.data.publication.bookPublicationName
          }
        ]
      }));
      setPublication({ id: null, bookPublicationName: "" });
    }
  }

  useEffect(() => {
    (async () => {
      const { response, error } = await getOngoingConversion();
      if (response.status === "success") {
        PublicationDefaultValue(response.data.brandName);
        // setMetaData((prevState) => ({
        //   ...prevState,
        //   publications: [
        //     {
        //       // id: response.data.publication.id,
        //       bookPublicationName:
        //         response.data.brandName,
        //     },
        //   ],
        // }));
        setBooks([...response.data.uploadedBook]);
      }
    })();
  }, [modals.addNew, modals.addendums, currentStep, modals]);

  function handleBookCoverUpload(e, index) {
    e.preventDefault();
    const file = e.target.files[0];
    setMetaData((prevState) => {
      // prevState.bookCover.push(file);
      // return { ...prevState };
      prevState.bookCover[index] = file;
      return { ...prevState };
    });
  }

  // shortdescripton = 50;
  // long description = 254;

  function handleChangeText({ target }) {
    let { name, value } = target;
    if (name === "longDescription") {
      if (value.length > 500) value = metaData.longDescription;
    } else if (name === "shortDescription") {
      if (value.length > 100) value = metaData.shortDescription;
    } else if (name === "eBookPrice") {
      if (isNaN(value)) {
        return false;
      }
    } else if (name === "hardbookPrice") {
      if (isNaN(value)) {
        return false;
      }
    } else if (name === "pageNoStartsAt" && value) {
      value = Math.abs(parseInt(value, 10));
    }

    setMetaData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }

  async function handleActivate() {
    setMiniLoader(true);
    const { response, error } = await addABookStepFourth(
      metaData,
      backgroundColor
    );
    const Response = JSON.parse(response);
    if (Response.status === "success") {
      setMiniLoader(false);
      setCurrentStep(1);
      setNewBookAdded(true);
      setModals((prevState) => ({ ...prevState, uploadByBook: false }));

      // setUploadedBookData({});
      if (currentStep > 3) {
        setMetaData({
          bookId: "",
          title: "",
          bookCover: [],
          ISBN: "",
          category: [],
          edition: "",
          authors: [],
          publications: [],
          price: null,
          validity: null,
          shortDescription: "",
          longDescription: "",
          numberOfPages: null,
          customKeyName: null,
          customValueName: null,
          printedBookCost: null,
          eBookPrice: 0,
          noOfPages: 0,
          validity: "",
          isPrintedBookAvailable: false,
          additionalField: {
            name: "",
            value: "",
            enable: false
          },
          pageNoStartsAt:1,
          hardbookPrice:0
        });
        setBackgroundColors("");
        setPaid(false);
      }
    } else {
      let resp = JSON.parse(response);

      notify(resp?.message ? resp?.message : "Something went wrong");
      setMiniLoader(false);
      setCurrentStep(4);
    }
  }

  function handleGotoForm(data) {
    setParentId(data.parentId);
    if (!data.parentId) {
      setModals((prev) => ({ ...prev, uploadByBook: true }));
      if (data.isPaid) {
        setMetaData((prev) => ({
          ...prev,
          bookId: data.id,
          validity: data.validity,
          noOfPages: data.countOfPages,
          hostingCharge: data.hostingCharge,
          conversionCharge: data.conversionCharge,
          title: data.title
          // publications:
        }));
        setCurrentStep(4);
        setUploadedBookData((prev) => ({
          prev,
          ...data
        }));
      } else {
        setUploadedBookData((prev) => ({
          prev,
          ...data
        }));
        setMetaData((prev) => ({
          ...prev,
          bookId: data.id,
          validity: data.validity,
          noOfPages: data.countOfPages,
          hostingCharge: data.hostingCharge,
          conversionCharge: data.conversionCharge
        }));
        setCurrentStep(2);
      }
    } else {
      setMetaData((prev) => ({
        ...prev,
        bookId: data.id,
        noOfPages: data.countOfPages,
        hostingCharge: data.hostingCharge,
        conversionCharge: data.conversionCharge
      }));
      setModals((prev) => ({
        ...prev,
        addendums: true,
        uploadByBook: false
      }));
      if (data.isPaid) {
        setCurrentStep(4);

        setUploadedBookData((prev) => ({
          prev,
          ...data
        }));
      } else {
        setUploadedBookData((prev) => ({
          prev,
          ...data
        }));

        setCurrentStep(2);
      }
    }
  }
  function onImageLoad(e) {
    const fav = new FastAverageColor();
    fav.getColorAsync(e.target).then((color) => {
      setBackgroundColors(color.hex);
    });
  }

  const validateStep4 =
    metaData.bookId == "" ||
    metaData.title == "" ||
    metaData.bookCover.length < 1 ||
    metaData.shortDescription == "" ||
    metaData.category.length == 0 ||
    metaData.edition == "" ||
    metaData.authors.length == 0 ||
    metaData.publications.length == 0 ||
    metaData.noOfPages == 0;

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  async function fileDrop(e) {
    e.preventDefault();
    setUploading(true);
    try {
      const file = e.dataTransfer.files[0];
      // console.log(file);
      const encryptedFile = await encryptFile(file);
      const { response, error } = await addABookStepZero();

      if (!response || response.status !== "success") {
        notify(
          response?.message || error?.message || "Failed to get upload URL. Please try again."
        );
        setUploading(false);
        return;
      }

      const { responses, errors } = await addABookStepalpha(
        encryptedFile,
        response.data.url
      );
      if (!responses || errors) {
        notify(
          errors?.message || "Failed to upload file to S3. Please try again."
        );
        setUploading(false);
        return;
      }

      const { responsed, error: uploadError } = await addABookStepFirst(
        response.data.key,
        file.name
      );
      
      if (!responsed || uploadError) {
        notify(
          uploadError?.message || responsed?.message || "Failed to process book upload. Please try again."
        );
        setUploading(false);
        return;
      }

      if (responsed.status === "success") {
        setUploadedBookData({ ...responsed.data.uploadedBook });
        setCurrentStep(2);
        setUploading(false);
        setMetaData((prevState) => ({
          ...prevState,
          noOfPages: responsed.data.uploadedBook.countOfPages,
          bookId: responsed.data.uploadedBook.id,
          publicationId: responsed.data.uploadedBook.publicationId,
          hostingCharge: responsed.data.uploadedBook.hostingCharge,
          conversionCharge: responsed.data.uploadedBook.conversionCharge
        }));
      } else {
        notify(
          responsed?.message || "Something went wrong"
        );
        setUploading(false);
        setMiniLoader(false);
      }
    } catch (err) {
      console.error("Error in fileDrop:", err);
      notify("An unexpected error occurred. Please try again.");
      setUploading(false);
      setMiniLoader(false);
    }
  }
  const fileDropImage = (e, index) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    // setMetaData((prevState) => {
    //   prevState.bookCover.push(file);
    //   return { ...prevState };
    // });
    setMetaData((prevState) => {
      prevState.bookCover[index] = file;
      return { ...prevState };
    });
  };

  useEffect(() => {
    switch (currentStep) {
      case 1:
        setRenderedStep(
          <div className="flex justify-center items-center bg-[#f3ebf2] w-[970px] h-[350px] mt-3 mx-auto border-[1.5px] border-dashed border-primary-dark">
            <div className="flex items-center justify-center flex-col">
              {!uploading ? (
                <div
                  className="flex items-center justify-center flex-col"
                  onDragOver={dragOver}
                  onDragEnter={dragEnter}
                  onDragLeave={dragLeave}
                  onDrop={fileDrop}
                >
                  <svg
                    width="90"
                    height="94"
                    viewBox="0 0 90 94"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.11875 76.5751C8.81625 77.6717 9.99 78.3337 11.25 78.3337H67.5C69 78.3337 70.3575 77.4015 70.9462 75.9601L82.1963 48.5435C82.4428 47.9479 82.5434 47.2976 82.4892 46.6512C82.435 46.0048 82.2275 45.3827 81.8856 44.841C81.5436 44.2993 81.078 43.855 80.5306 43.5482C79.9832 43.2414 79.3712 43.0818 78.75 43.0837H75V31.3337C75 27.0136 71.6362 23.5003 67.5 23.5003H42.5437L32.9587 15.667H15C10.8637 15.667 7.5 19.1802 7.5 23.5003V74.417H7.52625C7.51789 75.1813 7.72385 75.9315 8.11875 76.5751ZM67.5 31.3337V43.0837H22.5C21 43.0837 19.6425 44.0158 19.0537 45.4572L15 55.3389V31.3337H67.5Z"
                      fill="#DAC5D7"
                    />
                  </svg>
                  <h3 className="font-[500] text-heading text-h3 mb-3 mt-2">
                    Drag &#38; Drop or{" "}
                    <label
                      htmlFor="book_drop"
                      className="cursor-pointer text-tertiary-dark underline"
                    >
                      Browse
                    </label>{" "}
                  </h3>
                  <p className="text-secondary-light text-p1">
                    Only PDF Supported
                  </p>
                  <input
                    onChange={handleStepFirst}
                    id="book_drop"
                    className="hidden"
                    type="file"
                    accept=".pdf"
                  />
                </div>
              ) : (
                <div>
                  <div className="flex items-center justify-center flex-col">
                    <svg
                      className="animate-spin ml-1 mr-3 h-12 w-12 text-[#702963]"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-20"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  </div>

                  <h3 className="font-[500] text-center text-heading text-h3 mb-3 mt-2">
                    Upload in Progress...
                  </h3>
                  <p className="text-secondary-light text-center text-p1">
                    Please wait while the book gets uploaded
                  </p>
                </div>
              )}
            </div>
          </div>
        );
        break;

      case 2:
        setRenderedStep(
          <div className="flex border-[1.5px] border-solid border-primary-dark-10 p-4  w-[902px] h-[370px] mt-3 mx-auto ">
            {/* <div className="w-1/3 ">
              <div className="relative h-[361px] w-[278px] mx-auto drop-shadow-[15px_15px_10px_rgba(0,0,0,0.25)]">
                <img src={Book} alt="book" />
                <button className="rounded-md w-[133px] h-8 absolute bottom-12 left-[68px] bg-[#979797] text-primary-white ">
                  Page 1 of {uploadedBookData.countOfPages}
                </button>
              </div>
            </div> */}
            <div className="w-full px-10 pt-4 text-left ">
              <p className="text-secondary-light text-h5 text-justify mb-6">
                Charges for Conversion of the Uploaded Book
              </p>
              <div className="flex mb-[10px]">
                <p className="text-h5 text-secondary-dark font-semibold mr-[101px]">
                  No. of Pages
                </p>
                <h4 className="text-h5 text-heading font-semibold">
                  {uploadedBookData.countOfPages}
                </h4>
              </div>
              <div className="flex mb-[8px]">
                <p className="text-h5 text-secondary-dark font-semibold mr-[70px] ">
                  Validity Package
                </p>
                <div className="group relative">
                  <button
                    onClick={() => setFilterSort(true)}
                    className="flex items-center font-semibold justify-evenly text-secondary-dark bg-neutral-10 h-8 w-[107px]"
                  >
                    <span>{filterData} Years</span>
                    <span className="ml-2 bg-secondary-yellow w-4 h-4 rounded-sm flex justify-center items-center">
                      <svg
                        width="10"
                        height="5"
                        viewBox="0 0 10 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 5L0 0H10L5 5Z" fill="#7A7976" />
                      </svg>
                    </span>
                  </button>
                  <div
                    className={`${
                      filterSort ? "flex" : "hidden"
                    } group-hover:flex flex-col absolute top-[33px] left-0 bg-primary-white w-[107px] h-8`}
                  >
                    {sortDropdown.map((elm, index) => (
                      <span
                        key={index}
                        onClick={() => changeData(elm)}
                        className="w-full cursor-pointer z-50 bg-primary-white border-1 border-[#f0f0f0] text-secondary-light p-2 hover:bg-[#f0f0f0] text-left h-8 flex items-center text-p1"
                      >
                        {elm} Years
                      </span>
                    ))}
                  </div>
                </div>
                {/* <p className="ml-3 text-tertiary-dark font-medium">
                  ={" "}
                  {(
                    parseInt(filterData) *
                    parseFloat(uploadedBookData.hostingCharge)
                  ).toFixed(2)}
                  Tokens
                </p> */}
              </div>

              <div className="relative flex mb-[10px]">
                <p className="flex items-center text-h5 text-secondary-dark font-semibold mr-6 ">
                  Conversion charges
                  <span
                    onMouseEnter={(e) =>
                      setHover((prevState) => ({
                        ...prevState,
                        conversionCharges: true
                      }))
                    }
                    className="ml-1"
                  >
                    <svg
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                        fill="#C5C5C5"
                      />
                    </svg>
                  </span>
                </p>
                <h4 className="text-h5 text-heading font-semibold">
                  {uploadedBookData.conversionCharge} Tokens
                </h4>
                {hover.conversionCharges && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    // className="grid grid-cols-[40%_60%] grid-rows-[repeat(4,25%)] absolute top-0 left-48 w-[187px] h-[101px] border-[0.5px] border-solid border-[rgba(182,182,182,0.33)] bg-[#fbfafb]"
                    className="p-2 absolute top-0 left-48 w-[187px] border-[0.5px] border-solid border-[rgba(182,182,182,0.33)] bg-[#fbfafb]"
                  >
                    <p className="text-tertiary-dark text-[13px] font-medium text-left">
                      8 tokens per page
                    </p>
                    {/* <span className="absolute top-2 -left-3"></span>
                    <p className="w-full h-full row-span-[0/1] border-b-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-secondary-light text-[12px] flex justify-center items-center">
                      Pages
                    </p>
                    <p className="w-full h-full row-span-[0/1] col-span-[1/2] border-b-[0.5px] border-l-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-secondary-light text-[12px] flex justify-center items-center ">
                      Charges/ Page
                    </p>
                    <p className="w-full h-full row-span-[1/2] border-b-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-secondary-light text-[12px] flex justify-center items-center">
                      1-500
                    </p>
                    <p className="w-full h-full row-span-[1/2] col-span-[1/2] border-b-[0.5px] border-l-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-[rgba(112,41,99,0.67)] text-[12px] flex justify-center items-center ">
                      10 Tokens
                    </p>
                    <p className="w-full h-full row-span-[2/3] border-b-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-secondary-light text-[12px] flex justify-center items-center">
                      501-2000
                    </p>
                    <p className="w-full h-full row-span-[2/3] col-span-[1/2] border-b-[0.5px] border-l-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-[rgba(112,41,99,0.67)] text-[12px] flex justify-center items-center ">
                      9 Tokens
                    </p>
                    <p className="w-full h-full row-span-[3/4] border-b-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-secondary-light text-[12px] flex justify-center items-center">
                      Above 2000
                    </p>
                    <p className="w-full h-full row-span-[3/4] col-span-[1/2] border-b-[0.5px] border-l-[0.5px] border-solid border-[rgba(174,174,174,0.26)] text-[rgba(112,41,99,0.67)] text-[12px] flex justify-center items-center ">
                      8 Tokens
                    </p> */}
                    <button
                      onClick={() =>
                        setHover((prevState) => ({
                          ...prevState,
                          conversionCharges: false
                        }))
                      }
                      className="absolute top-2 right-2"
                    >
                      <svg
                        width="5"
                        height="5"
                        viewBox="0 0 5 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.80964 4.82838C4.69011 4.93643 4.528 4.99714 4.35897 4.99714C4.18994 4.99714 4.02783 4.93643 3.9083 4.82838L2.50027 3.37344L1.09223 4.8279C1.03322 4.88212 0.962925 4.92524 0.885391 4.95478C0.807858 4.98432 0.724623 4.99969 0.640487 5C0.556352 5.00031 0.472981 4.98555 0.395184 4.95659C0.317387 4.92762 0.246703 4.88502 0.18721 4.83123C0.127716 4.77745 0.0805912 4.71354 0.048552 4.64321C0.0165128 4.57288 0.000193788 4.4975 0.00053638 4.42144C0.000878972 4.34538 0.0178763 4.27013 0.050548 4.20003C0.0832197 4.12994 0.130919 4.06638 0.190895 4.01304L1.65576 2.50048L0.190364 0.986961C0.130388 0.933616 0.0826886 0.870062 0.0500169 0.799967C0.0173452 0.729872 0.000347876 0.654623 5.28423e-06 0.578559C-0.000337307 0.502495 0.0159817 0.427123 0.0480209 0.35679C0.0800601 0.286457 0.127185 0.222554 0.186679 0.168769C0.246172 0.114983 0.316856 0.0723792 0.394653 0.0434138C0.47245 0.0144485 0.555821 -0.000304946 0.639956 4.77726e-06C0.724092 0.000314501 0.807327 0.0156811 0.88486 0.0452183C0.962394 0.0747555 1.03269 0.117879 1.0917 0.1721L2.50027 1.62752L3.9083 0.1721C3.96731 0.117879 4.03761 0.0747555 4.11514 0.0452183C4.19267 0.0156811 4.27591 0.000314501 4.36004 4.77726e-06C4.44418 -0.000304946 4.52755 0.0144485 4.60535 0.0434138C4.68314 0.0723792 4.75383 0.114983 4.81332 0.168769C4.87281 0.222554 4.91994 0.286457 4.95198 0.35679C4.98402 0.427123 5.00034 0.502495 4.99999 0.578559C4.99965 0.654623 4.98265 0.729872 4.94998 0.799967C4.91731 0.870062 4.86961 0.933616 4.80964 0.986961L3.34477 2.50048L4.80964 4.01304C4.8689 4.06655 4.91591 4.1301 4.94798 4.20005C4.98006 4.27001 4.99657 4.34499 4.99657 4.42071C4.99657 4.49643 4.98006 4.57141 4.94798 4.64136C4.91591 4.71132 4.8689 4.77487 4.80964 4.82838Z"
                          fill="black"
                          fill-opacity="0.53"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>
              <div className="flex mb-[10px]">
                <p className="relative flex items-center text-h5 text-secondary-dark font-semibold mr-[50px] ">
                  Hosting Charges
                  <span
                    onMouseEnter={(e) =>
                      setHover((prevState) => ({
                        ...prevState,
                        hostingCharges: true
                      }))
                    }
                    className="ml-1"
                  >
                    <svg
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                        fill="#C5C5C5"
                      />
                    </svg>
                  </span>
                  {hover.hostingCharges && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="p-3 absolute top-0 left-48 w-[276px] h-fit border-[0.5px] border-solid border-[rgba(182,182,182,0.33)] bg-[#fbfafb]"
                    >
                      <span className="absolute top-2 -left-3"></span>
                      <p className="text-secondary-light text-[13px] font-medium text-left mb-2">
                        Hosting charges
                      </p>
                      <p className="text-tertiary-dark text-[13px] font-medium text-left mb-2">
                        500 Tokens/ 1000 Pages
                      </p>
                      <p className="text-secondary-light text-[13px] font-medium text-left mb-2">
                        Buffer charges are also included here
                      </p>
                      <button
                        onClick={() =>
                          setHover((prevState) => ({
                            ...prevState,
                            hostingCharges: false
                          }))
                        }
                        className="absolute top-2 right-2"
                      >
                        <svg
                          width="5"
                          height="5"
                          viewBox="0 0 5 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.80964 4.82838C4.69011 4.93643 4.528 4.99714 4.35897 4.99714C4.18994 4.99714 4.02783 4.93643 3.9083 4.82838L2.50027 3.37344L1.09223 4.8279C1.03322 4.88212 0.962925 4.92524 0.885391 4.95478C0.807858 4.98432 0.724623 4.99969 0.640487 5C0.556352 5.00031 0.472981 4.98555 0.395184 4.95659C0.317387 4.92762 0.246703 4.88502 0.18721 4.83123C0.127716 4.77745 0.0805912 4.71354 0.048552 4.64321C0.0165128 4.57288 0.000193788 4.4975 0.00053638 4.42144C0.000878972 4.34538 0.0178763 4.27013 0.050548 4.20003C0.0832197 4.12994 0.130919 4.06638 0.190895 4.01304L1.65576 2.50048L0.190364 0.986961C0.130388 0.933616 0.0826886 0.870062 0.0500169 0.799967C0.0173452 0.729872 0.000347876 0.654623 5.28423e-06 0.578559C-0.000337307 0.502495 0.0159817 0.427123 0.0480209 0.35679C0.0800601 0.286457 0.127185 0.222554 0.186679 0.168769C0.246172 0.114983 0.316856 0.0723792 0.394653 0.0434138C0.47245 0.0144485 0.555821 -0.000304946 0.639956 4.77726e-06C0.724092 0.000314501 0.807327 0.0156811 0.88486 0.0452183C0.962394 0.0747555 1.03269 0.117879 1.0917 0.1721L2.50027 1.62752L3.9083 0.1721C3.96731 0.117879 4.03761 0.0747555 4.11514 0.0452183C4.19267 0.0156811 4.27591 0.000314501 4.36004 4.77726e-06C4.44418 -0.000304946 4.52755 0.0144485 4.60535 0.0434138C4.68314 0.0723792 4.75383 0.114983 4.81332 0.168769C4.87281 0.222554 4.91994 0.286457 4.95198 0.35679C4.98402 0.427123 5.00034 0.502495 4.99999 0.578559C4.99965 0.654623 4.98265 0.729872 4.94998 0.799967C4.91731 0.870062 4.86961 0.933616 4.80964 0.986961L3.34477 2.50048L4.80964 4.01304C4.8689 4.06655 4.91591 4.1301 4.94798 4.20005C4.98006 4.27001 4.99657 4.34499 4.99657 4.42071C4.99657 4.49643 4.98006 4.57141 4.94798 4.64136C4.91591 4.71132 4.8689 4.77487 4.80964 4.82838Z"
                            fill="black"
                            fill-opacity="0.53"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </p>
                <h4 className="text-h5 text-heading font-semibold">
                  {(
                    parseInt(filterData) *
                    parseFloat(uploadedBookData.hostingCharge)
                  ).toFixed(2)}{" "}
                  Tokens
                </h4>
              </div>
              <div className="flex mt-4">
                <p className="text-h4 text-heading font-semibold mr-[92px] ">
                  Total Tokens
                </p>
                <h4 className="text-h5 text-heading font-semibold">
                  {(
                    parseFloat(uploadedBookData.conversionCharge) +
                    parseInt(filterData) *
                      parseFloat(uploadedBookData.hostingCharge)
                  ).toFixed(2)}
                </h4>
              </div>

              <div className="flex mt-8 justify-end">
                <BtnSmall onClick={handleAcceptCharges}>
                  {miniLoader ? (
                    <div className="flex">
                      <svg
                        className="animate-spin ml-1 mr-3 h-5 w-5 "
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-20"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </div>
                  ) : (
                    "Accept Charges"
                  )}
                </BtnSmall>
              </div>
            </div>
          </div>
        );
        break;

      case 3:
        setRenderedStep(
          <div className=" border-[1.5px] border-solid border-primary-dark-10 p-6  w-[902px] h-[370px] mt-3 mx-auto ">
            {!paid ? (
              <>
                <h2 className="text-heading font-semibold text-left mb-4">
                  Payment Details
                </h2>
                {/* <p className="text-secondary-light text-h5 text-justify mb-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. At
                  aliquet ut facilisi nulla mauris iopsum. Pipsum dolor sit
                  ametre, consectetur adipiscing elit. At aliquet ut facilisi
                  nulla mauris.
                </p> */}
                <div className="flex items-center pl-4 mb-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                  <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                    &#8377;
                  </div>
                  <p className="text-h5 text-secondary-dark font-semibold">
                    Total Tokens Available:{" "}
                    <span className="text-heading  ml-6">
                      {walletDetails.myCredits.credits.toFixed(3)}
                    </span>
                  </p>
                </div>
                <div className="mb-4 flex items-center pl-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                  <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                    &#8377;
                  </div>
                  <p className=" text-h5 text-secondary-dark font-semibold">
                    Amount to Pay:{" "}
                    <span className="text-heading  ml-[73px]">
                      {amountToPay}
                    </span>
                  </p>
                </div>
                {inSufficientBalance && (
                  <p className="flex items-center text-secondary-light text-h5 text-left mb-2">
                    <span className="mr-2">
                      <svg
                        width="25"
                        height="22"
                        viewBox="0 0 25 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.0265 0C5.39521 0 0 4.85983 0 10.8333C0 16.8068 5.42058 21.6667 12.0833 21.6667C18.7461 21.6667 24.1667 16.8068 24.1667 10.8333C24.1667 4.85983 18.7207 0 12.0265 0ZM13.2917 16.25H10.875V14.0833H13.2917V16.25ZM13.2917 11.9167H10.875V5.41667H13.2917V11.9167Z"
                          fill="#FF3737"
                        />
                      </svg>
                    </span>
                    You have Insufficient Balance to complete this transaction.
                    <RouterLink
                      to={ROUTES.WALLET}
                      className="ml-2 font-semibold text-tertiary-dark underline"
                    >
                      Add Tokens
                    </RouterLink>
                  </p>
                )}
                {inSufficientBalance ? (
                  <div className="flex justify-end items-center">
                    <BtnSmallDisabled onClick={() => 1}>Pay</BtnSmallDisabled>
                  </div>
                ) : (
                  <div className="flex justify-end items-center gap-3 mt-10">
                    <BtnSmallWhite onClick={() => setCurrentStep(2)}>
                      Back
                    </BtnSmallWhite>
                    <BtnSmall onClick={handleStepSecond}>
                      {miniLoader ? (
                        <div className="flex">
                          <svg
                            className="animate-spin ml-1 mr-3 h-5 w-5 "
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              class="opacity-20"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              stroke-width="4"
                            ></circle>
                            <path
                              class="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing...
                        </div>
                      ) : (
                        "Pay"
                      )}
                    </BtnSmall>
                  </div>
                )}
              </>
            ) : (
              <>
                <h2 className="text-heading font-semibold text-left mb-4">
                  Authorise Payment
                </h2>
                <p className="text-secondary-light text-h5 text-justify mb-8">
                  OTP has been sent to your registered mobile number and email
                  address. Please authorize the payment with the OTP.
                </p>
                <div className="flex items-center mb-8">
                  {otps.map((element, index) => {
                    return (
                      <input
                        type="text"
                        disabled={miniLoader}
                        key={index}
                        onChange={(e) => handleChnges(e.target, index)}
                        value={element}
                        name="otp"
                        maxLength="1"
                        onFocus={(e) => e.target.select()}
                        autoFocus={index === 0}
                        className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                      />
                    );
                  })}
                </div>

                <p className="mb-6 text-left text-heading-false font-semibold text-p1">
                  Didn't receive the OTP?{" "}
                  <span className="text-secondary-light underline">
                    <Timeout handleClick={handleStepSecond} start={60} />
                  </span>
                </p>
                {otps[5] == "" ? (
                  <div className="flex justify-end items-center">
                    <BtnSmallDisabled
                      onClick={() =>
                        setModals((prevState) => ({
                          ...prevState,
                          addNew: false,
                          uploadByBook: uploadByBook ? true : false
                        }))
                      }
                    >
                      Submit
                    </BtnSmallDisabled>
                  </div>
                ) : (
                  <div className="flex justify-end">
                    <BtnSmall onClick={handleStepThird}>
                      {miniLoader ? (
                        <div className="flex">
                          <svg
                            className="animate-spin ml-1 mr-3 h-5 w-5 "
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              class="opacity-20"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              stroke-width="4"
                            ></circle>
                            <path
                              class="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing...
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </BtnSmall>
                  </div>
                )}
              </>
            )}
          </div>
        );
        break;

      case 4:
        setRenderedStep(
          <form className="scrollbar scrollbar-thumb-thumb scrollbar-track-track border-[1.5px] border-solid border-primary-dark-10 p-6  w-[902px] h-[370px] mt-3 mx-auto ">
            <h2 className="text-heading font-semibold text-left mb-8">
              Enter book details
            </h2>
            <div className="w-full flex justify-between items-center mb-6">
              <div className="flex flex-col">
                <label
                  className="text-heading-false font-semibold"
                  htmlFor="book_title"
                >
                  Book Title<span className="text-tertiary-dark">*</span>
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="book_title"
                  name="title"
                  value={metaData.title}
                  onChange={handleChangeText}
                  type="text"
                  placeholder="Enter Book Title"
                />
              </div>
              <div className="flex flex-col">
                <label
                  className="text-heading-false font-semibold"
                  htmlFor="isbn"
                >
                  ISBN
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="isbn"
                  name="ISBN"
                  type="text"
                  value={metaData.ISBN}
                  placeholder="Enter ISBN"
                  onChange={handleChangeText}
                />
              </div>
            </div>
            <div className="w-full flex justify-between items-center mb-6">
              <div className="flex flex-col">
                <label
                  className="text-heading-false font-semibold"
                  htmlFor="author"
                >
                  Edition<span className="text-tertiary-dark">*</span>
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="edition"
                  name="edition"
                  type="text"
                  placeholder="Enter Edition"
                  value={metaData.edition}
                  onChange={handleChangeText}
                />
              </div>
              <div className="flex flex-col">
                <label
                  className="text-heading-false font-semibold"
                  htmlFor="publication"
                >
                  No. of Pages<span className="text-tertiary-dark">*</span>
                </label>
                <input
                  className="bg-input appearance-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="noOfPages"
                  name="noOfPages"
                  type="number"
                  placeholder="Enter publication"
                  value={metaData.noOfPages}
                  onChange={handleChangeText}
                  disabled
                />
              </div>
            </div>
            <div className="w-full flex justify-between items-center mb-6">
              <div className="flex flex-col">
                <label
                  className="text-heading-false font-semibold"
                  htmlFor="publication"
                >
                  Validity<span className="text-tertiary-dark">*</span>
                </label>
                <input
                  className="bg-input appearance-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="noOfPages"
                  name="noOfPages"
                  type="number"
                  placeholder="Enter publication"
                  value={metaData.validity}
                  // onChange={handleChangeText}
                  disabled
                />
              </div>
            </div>

            <p className="text-heading-false font-semibold">
              Category<span className="text-tertiary-dark">*</span>
            </p>
            <div className="relative flex items-center bg-input h-[52px] mt-2 border-[1.5px] border-solid border-primary-dark-10 mb-6">
              {metaData?.category.map((item, index) => (
                <div
                  key={item.id}
                  className="flex justify-between items-center px-1 relative ml-3 bg-[#939CECC7] w-[122px] h-[38px]"
                >
                  <ReactTooltip
                    place="right"
                    backgroundColor="#737272"
                    type="success"
                    effect="solid"
                    offset={{ bottom: 0 }}
                    delayShow="200"
                  />
                  <p className="text-center text-primary-white capitalize whitespace-nowrap overflow-hidden text-ellipsis">
                    {item.bookCategoryName}
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMetaData((prevState) => {
                        prevState.category = prevState.category.filter(
                          (item2) => item2 !== item
                        );
                        return { ...prevState };
                      });
                    }}
                    className="mx-1"
                    data-tip="Remove Category"
                  >
                    <svg
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6954 11.7597C12.5042 11.911 12.2448 11.996 11.9744 11.996C11.7039 11.996 11.4445 11.911 11.2533 11.7597L9.00043 9.72282L6.74757 11.7591C6.65316 11.835 6.54068 11.8953 6.41663 11.9367C6.29257 11.978 6.1594 11.9996 6.02478 12C5.89016 12.0004 5.75677 11.9798 5.63229 11.9392C5.50782 11.8987 5.39472 11.839 5.29954 11.7637C5.20435 11.6884 5.12895 11.599 5.07768 11.5005C5.02642 11.402 5.00031 11.2965 5.00086 11.19C5.00141 11.0835 5.0286 10.9782 5.08088 10.88C5.13315 10.7819 5.20947 10.6929 5.30543 10.6183L7.64922 8.50067L5.30458 6.38175C5.20862 6.30706 5.1323 6.21809 5.08003 6.11995C5.02775 6.02182 5.00056 5.91647 5.00001 5.80998C4.99946 5.70349 5.02557 5.59797 5.07683 5.49951C5.1281 5.40104 5.2035 5.31158 5.29869 5.23628C5.39388 5.16098 5.50697 5.10133 5.63144 5.06078C5.75592 5.02023 5.88931 4.99957 6.02393 5.00001C6.15855 5.00044 6.29172 5.02195 6.41578 5.06331C6.53983 5.10466 6.65231 5.16503 6.74672 5.24094L9.00043 7.27852L11.2533 5.24094C11.3477 5.16503 11.4602 5.10466 11.5842 5.06331C11.7083 5.02195 11.8415 5.00044 11.9761 5.00001C12.1107 4.99957 12.2441 5.02023 12.3686 5.06078C12.493 5.10133 12.6061 5.16098 12.7013 5.23628C12.7965 5.31158 12.8719 5.40104 12.9232 5.49951C12.9744 5.59797 13.0005 5.70349 13 5.80998C12.9994 5.91647 12.9722 6.02182 12.92 6.11995C12.8677 6.21809 12.7914 6.30706 12.6954 6.38175L10.3516 8.50067L12.6954 10.6183C12.7902 10.6932 12.8655 10.7821 12.9168 10.8801C12.9681 10.978 12.9945 11.083 12.9945 11.189C12.9945 11.295 12.9681 11.4 12.9168 11.4979C12.8655 11.5958 12.7902 11.6848 12.6954 11.7597Z"
                        fill="white"
                        fill-opacity="0.9"
                      />
                    </svg>
                  </button>
                </div>
              ))}
              <input
                type="text"
                className="bg-input text-h5 border-0 outline-0 min-w-20 h-full ml-4"
                placeholder="Select Categories"
                value={category.bookCategoryName}
                onChange={(e) =>
                  setCategory((prevState) => ({
                    ...prevState,
                    bookCategoryName: e.target.value
                  }))
                }
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const { response, error } = await addABookAddCategory(
                      category.bookCategoryName
                    );
                    if (response.status === "success") {
                      setMetaData((prevState) => ({
                        ...prevState,
                        category: [
                          ...prevState.category,
                          {
                            id: response.data.category.id,
                            bookCategoryName:
                              response.data.category.bookCategoryName
                          }
                        ]
                      }));
                      setCategory({ id: null, bookCategoryName: "" });
                      setShowCategorySuggestion(false);
                    }
                  }
                }}
              />
              {showCategorySuggestion && (
                <div className="bg-primary-white absolute top-[50px] z-[999] left-0 w-full">
                  {categorySuggestionArr.length > 0 ? (
                    categorySuggestionArr.map((item, index) => (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          let temp = true;

                          metaData.category.forEach((element) => {
                            if (
                              element.bookCategoryName === item.bookCategoryName
                            )
                              temp = false;
                          });

                          temp &&
                            setMetaData((prevState) => ({
                              ...prevState,
                              category: [
                                ...prevState.category,
                                {
                                  id: item.id,
                                  bookCategoryName: item.bookCategoryName
                                }
                              ]
                            }));
                          setCategory({ id: null, bookCategoryName: "" });
                          setShowCategorySuggestion(false);
                        }}
                        className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border"
                        key={item.id}
                      >
                        {item.bookCategoryName}
                      </button>
                    ))
                  ) : (
                    <p className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border">
                      No Categories Found, Please click enter to Add Category
                    </p>
                  )}
                </div>
              )}
            </div>

            <p className="text-heading-false font-semibold">
              Author<span className="text-tertiary-dark">*</span>
            </p>
            <div className="z-40 relative flex items-center bg-input h-[52px] mt-2 border-[1.5px] border-solid border-primary-dark-10 mb-6">
              {metaData?.authors.map((item) => (
                <div
                  key={item.id}
                  className="flex justify-between px-1 items-center relative ml-3 bg-[#939CECC7] w-[122px] h-[38px]"
                >
                  <ReactTooltip
                    place="right"
                    backgroundColor="#737272"
                    type="success"
                    effect="solid"
                    offset={{ bottom: 0 }}
                    delayShow="200"
                  />
                  <p className="text-center text-primary-white capitalize whitespace-nowrap overflow-hidden text-ellipsis">
                    {item.bookAuthorName}
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMetaData((prevState) => {
                        prevState.authors = prevState.authors.filter(
                          (item2) => item2 !== item
                        );
                        return { ...prevState };
                      });
                    }}
                    className="mx-1"
                    data-tip="Remove Author"
                  >
                    <svg
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6954 11.7597C12.5042 11.911 12.2448 11.996 11.9744 11.996C11.7039 11.996 11.4445 11.911 11.2533 11.7597L9.00043 9.72282L6.74757 11.7591C6.65316 11.835 6.54068 11.8953 6.41663 11.9367C6.29257 11.978 6.1594 11.9996 6.02478 12C5.89016 12.0004 5.75677 11.9798 5.63229 11.9392C5.50782 11.8987 5.39472 11.839 5.29954 11.7637C5.20435 11.6884 5.12895 11.599 5.07768 11.5005C5.02642 11.402 5.00031 11.2965 5.00086 11.19C5.00141 11.0835 5.0286 10.9782 5.08088 10.88C5.13315 10.7819 5.20947 10.6929 5.30543 10.6183L7.64922 8.50067L5.30458 6.38175C5.20862 6.30706 5.1323 6.21809 5.08003 6.11995C5.02775 6.02182 5.00056 5.91647 5.00001 5.80998C4.99946 5.70349 5.02557 5.59797 5.07683 5.49951C5.1281 5.40104 5.2035 5.31158 5.29869 5.23628C5.39388 5.16098 5.50697 5.10133 5.63144 5.06078C5.75592 5.02023 5.88931 4.99957 6.02393 5.00001C6.15855 5.00044 6.29172 5.02195 6.41578 5.06331C6.53983 5.10466 6.65231 5.16503 6.74672 5.24094L9.00043 7.27852L11.2533 5.24094C11.3477 5.16503 11.4602 5.10466 11.5842 5.06331C11.7083 5.02195 11.8415 5.00044 11.9761 5.00001C12.1107 4.99957 12.2441 5.02023 12.3686 5.06078C12.493 5.10133 12.6061 5.16098 12.7013 5.23628C12.7965 5.31158 12.8719 5.40104 12.9232 5.49951C12.9744 5.59797 13.0005 5.70349 13 5.80998C12.9994 5.91647 12.9722 6.02182 12.92 6.11995C12.8677 6.21809 12.7914 6.30706 12.6954 6.38175L10.3516 8.50067L12.6954 10.6183C12.7902 10.6932 12.8655 10.7821 12.9168 10.8801C12.9681 10.978 12.9945 11.083 12.9945 11.189C12.9945 11.295 12.9681 11.4 12.9168 11.4979C12.8655 11.5958 12.7902 11.6848 12.6954 11.7597Z"
                        fill="white"
                        fill-opacity="0.9"
                      />
                    </svg>
                  </button>
                </div>
              ))}
              <input
                type="text"
                className="bg-input text-h5 border-0 outline-0 min-w-20 h-full ml-4"
                placeholder="Enter Authors"
                value={author.bookAuthorName}
                onChange={(e) =>
                  setAuthor((prevState) => ({
                    ...prevState,
                    bookAuthorName: e.target.value
                  }))
                }
                onKeyDown={async (e) => {
                  if (e.code === "Enter") {
                    e.preventDefault();
                    const { response, error } = await addABookAddAuthor(
                      author.bookAuthorName
                    );

                    if (response.status === "success") {
                      setMetaData((prevState) => ({
                        ...prevState,
                        authors: [
                          ...prevState.authors,
                          {
                            id: response.data.author.id,
                            bookAuthorName: response.data.author.bookAuthorName
                          }
                        ]
                      }));
                      setAuthor({ id: null, bookAuthorName: "" });
                      setShowAuthorSuggestion(false);
                    }
                  }
                }}
              />
              {showAuthorSuggestion && (
                <div className="bg-primary-white absolute top-[50px] left-0 w-full">
                  {authorSuggestionArr.length > 0 ? (
                    authorSuggestionArr.map((item, index) => (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          let temp = true;
                          metaData.authors.forEach((element) => {
                            if (element.bookAuthorName === item.bookAuthorName)
                              temp = false;
                          });
                          temp &&
                            setMetaData((prevState) => ({
                              ...prevState,
                              authors: [
                                ...prevState.authors,
                                {
                                  id: item.id,
                                  bookAuthorName: item.bookAuthorName
                                }
                              ]
                            }));
                          setAuthor({ id: null, bookAuthorName: "" });
                          setShowAuthorSuggestion(false);
                        }}
                        className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border"
                        key={item.id}
                      >
                        {item.bookAuthorName}
                      </button>
                    ))
                  ) : (
                    <p className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border">
                      No suggestions found
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* publication search and add */}

            <p className="text-heading-false font-semibold">
              Publication<span className="text-tertiary-dark">*</span>
            </p>
            <div className="relative flex items-center  bg-input h-[52px] mt-2 border-[1.5px] border-solid border-primary-dark-10 mb-6">
              {metaData?.publications.map((item) => (
                <div
                  key={item.id}
                  className="flex justify-between px-1 items-center relative ml-3 bg-[#939CECC7] w-[122px] h-[38px]"
                >
                  <ReactTooltip
                    place="right"
                    backgroundColor="#737272"
                    type="success"
                    effect="solid"
                    offset={{ bottom: 0 }}
                    delayShow="200"
                  />
                  <p className="text-center text-primary-white whitespace-nowrap capitalize overflow-hidden text-ellipsis">
                    {item.bookPublicationName}
                  </p>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMetaData((prevState) => {
                        prevState.publications = prevState.publications.filter(
                          (item2) => item2 !== item
                        );
                        return { ...prevState };
                      });
                    }}
                    className="mx-1"
                    data-tip="Remove Publication"
                  >
                    <svg
                      width="19"
                      height="17"
                      viewBox="0 0 19 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6954 11.7597C12.5042 11.911 12.2448 11.996 11.9744 11.996C11.7039 11.996 11.4445 11.911 11.2533 11.7597L9.00043 9.72282L6.74757 11.7591C6.65316 11.835 6.54068 11.8953 6.41663 11.9367C6.29257 11.978 6.1594 11.9996 6.02478 12C5.89016 12.0004 5.75677 11.9798 5.63229 11.9392C5.50782 11.8987 5.39472 11.839 5.29954 11.7637C5.20435 11.6884 5.12895 11.599 5.07768 11.5005C5.02642 11.402 5.00031 11.2965 5.00086 11.19C5.00141 11.0835 5.0286 10.9782 5.08088 10.88C5.13315 10.7819 5.20947 10.6929 5.30543 10.6183L7.64922 8.50067L5.30458 6.38175C5.20862 6.30706 5.1323 6.21809 5.08003 6.11995C5.02775 6.02182 5.00056 5.91647 5.00001 5.80998C4.99946 5.70349 5.02557 5.59797 5.07683 5.49951C5.1281 5.40104 5.2035 5.31158 5.29869 5.23628C5.39388 5.16098 5.50697 5.10133 5.63144 5.06078C5.75592 5.02023 5.88931 4.99957 6.02393 5.00001C6.15855 5.00044 6.29172 5.02195 6.41578 5.06331C6.53983 5.10466 6.65231 5.16503 6.74672 5.24094L9.00043 7.27852L11.2533 5.24094C11.3477 5.16503 11.4602 5.10466 11.5842 5.06331C11.7083 5.02195 11.8415 5.00044 11.9761 5.00001C12.1107 4.99957 12.2441 5.02023 12.3686 5.06078C12.493 5.10133 12.6061 5.16098 12.7013 5.23628C12.7965 5.31158 12.8719 5.40104 12.9232 5.49951C12.9744 5.59797 13.0005 5.70349 13 5.80998C12.9994 5.91647 12.9722 6.02182 12.92 6.11995C12.8677 6.21809 12.7914 6.30706 12.6954 6.38175L10.3516 8.50067L12.6954 10.6183C12.7902 10.6932 12.8655 10.7821 12.9168 10.8801C12.9681 10.978 12.9945 11.083 12.9945 11.189C12.9945 11.295 12.9681 11.4 12.9168 11.4979C12.8655 11.5958 12.7902 11.6848 12.6954 11.7597Z"
                        fill="white"
                        fill-opacity="0.9"
                      />
                    </svg>
                  </button>
                </div>
              ))}
              <input
                type="text"
                className="bg-input text-h5 border-0 outline-0 min-w-20 h-full ml-4"
                placeholder="Type Publication name"
                value={publication.bookPublicationName}
                onChange={(e) =>
                  setPublication((prevState) => ({
                    ...prevState,
                    bookPublicationName: e.target.value
                  }))
                }
                onKeyDown={async (e) => {
                  if (e.code === "Enter") {
                    e.preventDefault();
                    const { response, error } = await addABookAddPublication(
                      publication.bookPublicationName
                    );

                    if (response.status === "success") {
                      setMetaData((prevState) => ({
                        ...prevState,
                        publications: [
                          ...prevState.publications,
                          {
                            id: response.data.publication.id,
                            bookPublicationName:
                              response.data.publication.bookPublicationName
                          }
                        ]
                      }));
                      setPublication({ id: null, bookPublicationName: "" });
                      setShowPublicationSuggestion(false);
                    }
                  }
                }}
              />
              {showPublicationSuggestion && (
                <div className="bg-primary-white absolute top-[50px] z-[999] left-0 w-full">
                  {publicationSuggestionArr.length > 0 ? (
                    publicationSuggestionArr.map((item, index) => {
                      return (
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            let temp = true;
                            metaData.publications.forEach((element) => {
                              if (
                                element.bookPublicationName ===
                                item.bookPublicationName
                              )
                                temp = false;
                            });

                            if (temp) {
                              setMetaData((prevState) => ({
                                ...prevState,
                                publications: [
                                  ...prevState.publications,
                                  {
                                    id: item.id,
                                    bookPublicationName:
                                      item.bookPublicationName
                                  }
                                ]
                              }));
                            }
                            setPublication({
                              id: null,
                              bookPublicationName: ""
                            });
                            setShowPublicationSuggestion(false);
                          }}
                          className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border"
                          key={item.id}
                        >
                          {item.bookPublicationName}
                        </button>
                      );
                    })
                  ) : (
                    <p className="pl-9 text-left text-montserrat font-semibold text-[18px] leading-[22px] w-full h-[53px] py-[10px]  hover:bg-[#f0f0f0] box-border">
                      No suggestions found
                    </p>
                  )}
                </div>
              )}
            </div>

            <label
              htmlFor="short_description"
              className="text-heading-false font-semibold"
            >
              Short Description<span className="text-tertiary-dark">*</span>
            </label>
            <textarea
              name="shortDescription"
              id="short_description"
              value={metaData.shortDescription}
              onChange={handleChangeText}
              placeholder="Enter Short Description (Between 1-100 characters)"
              maxlength="100"
              className="text-h5 border-[1.5px] focus:outline-none border-solid border-primary-dark-10 w-full h-[70px] text-justify p-4 text-secondary-dark font-semibold mt-2 mb-6 bg-input"
            ></textarea>

            <label
              htmlFor="long_description"
              className="text-heading-false font-semibold"
            >
              Long Description
            </label>
            <textarea
              name="longDescription"
              value={metaData.longDescription}
              onChange={handleChangeText}
              id="long_description"
              placeholder="Enter Long Description (Between 1-500 characters)"
              maxlength="500"
              className="text-h5 border-[1.5px] border-solid focus:outline-none border-primary-dark-10 w-full h-[150px] text-justify p-4 text-secondary-dark font-semibold mt-2 mb-6 bg-input"
            ></textarea>

            <label
              className="text-heading-false font-semibold"
              data-tip=" Both front and back cover images are required"
            >
              Upload a Book Cover<span className="text-tertiary-dark">*</span>
            </label>

            {metaData.bookCover.length === 0 ? (
              <div
                onDragOver={dragOver}
                onDragEnter={dragEnter}
                onDragLeave={dragLeave}
                onDrop={(e) => fileDropImage(e, 0)}
                className="flex justify-center flex-col items-center bg-[#F3EBF2] w-full h-[78px] border-[1.5px] border-dashed border-primary-dark-20 mt-2 mb-10"
              >
                <p className="text-secondary-dark text-h5">
                  Drag &#38; drop or{" "}
                  <label
                    htmlFor="book_cover"
                    className="underline text-p1 text-tertiary-dark cursor-pointer"
                  >
                    Browse
                  </label>
                  <p className="text-secondary-light text-p1">
                    Only Png/Jpg Files Supported
                  </p>
                </p>
                <input
                  onChange={(e) => handleBookCoverUpload(e, 0)}
                  id="book_cover"
                  type="file"
                  className="hidden "
                />
              </div>
            ) : (
              <div className="h-[133px] mt-4 mb-2 flex">
                {metaData.bookCover.map((cover, i) => (
                  <div
                    key={i + 90}
                    onDragOver={dragOver}
                    onDragEnter={dragEnter}
                    onDragLeave={dragLeave}
                    onDrop={(e) => fileDropImage(e, i)}
                    className="relative w-[103px] mr-3"
                  >
                    <img
                      className="h-full w-full block"
                      src={URL.createObjectURL(cover)}
                      alt="book cover"
                    />
                    <div className="h-full absolute top-0 left-0  bg-[#7029635C] flex items-center justify-center w-full ">
                      <label htmlFor={i}>
                        <svg
                          width="60"
                          height="44"
                          viewBox="0 0 60 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 16.2C28.8181 16.2 27.6478 16.4095 26.5558 16.8166C25.4639 17.2236 24.4718 17.8203 23.636 18.5724C22.8003 19.3246 22.1374 20.2175 21.6851 21.2003C21.2328 22.183 21 23.2363 21 24.3C21 25.3637 21.2328 26.417 21.6851 27.3997C22.1374 28.3825 22.8003 29.2754 23.636 30.0276C24.4718 30.7797 25.4639 31.3764 26.5558 31.7834C27.6478 32.1905 28.8181 32.4 30 32.4C32.3869 32.4 34.6761 31.5466 36.364 30.0276C38.0518 28.5085 39 26.4483 39 24.3C39 22.1517 38.0518 20.0915 36.364 18.5724C34.6761 17.0534 32.3869 16.2 30 16.2ZM54 8.1H46.8C46.2818 8.07873 45.7818 7.92177 45.3613 7.64838C44.9409 7.37499 44.6182 6.99707 44.433 6.561L42.57 1.5363C42.3835 1.10071 42.06 0.723462 41.6391 0.450634C41.2182 0.177806 40.7182 0.0212171 40.2 0H19.8C18.81 0 17.742 0.6912 17.433 1.5336L15.567 6.561C15.3815 6.99688 15.0587 7.37461 14.6383 7.64795C14.2179 7.92129 13.7181 8.07839 13.2 8.1H6C2.7 8.1 0 10.53 0 13.5V37.8C0 40.77 2.7 43.2 6 43.2H54C57.3 43.2 60 40.77 60 37.8V13.5C60 10.53 57.3 8.1 54 8.1ZM30 37.8C26.0218 37.8 22.2064 36.3777 19.3934 33.8459C16.5804 31.3142 15 27.8804 15 24.3C15 20.7196 16.5804 17.2858 19.3934 14.7541C22.2064 12.2223 26.0218 10.8 30 10.8C33.9782 10.8 37.7936 12.2223 40.6066 14.7541C43.4196 17.2858 45 20.7196 45 24.3C45 27.8804 43.4196 31.3142 40.6066 33.8459C37.7936 36.3777 33.9782 37.8 30 37.8ZM52.5 16.74C51.943 16.74 51.4089 16.5409 51.0151 16.1864C50.6213 15.832 50.4 15.3513 50.4 14.85C50.4 14.3487 50.6213 13.868 51.0151 13.5136C51.4089 13.1591 51.943 12.96 52.5 12.96C53.057 12.96 53.5911 13.1591 53.9849 13.5136C54.3787 13.868 54.6 14.3487 54.6 14.85C54.6 15.3513 54.3787 15.832 53.9849 16.1864C53.5911 16.5409 53.057 16.74 52.5 16.74Z"
                            fill="#F3EBF2"
                            fill-opacity="0.87"
                          />
                        </svg>
                      </label>
                      <input
                        id={i}
                        onChange={(e) =>
                          setMetaData((prevState) => {
                            prevState.bookCover[i] = e.target.files[0];
                            return { ...prevState };
                          })
                        }
                        type="file"
                        className="hidden"
                      />
                    </div>
                  </div>
                ))}
                {metaData.bookCover.length === 1 && (
                  <div
                    onDragOver={dragOver}
                    onDragEnter={dragEnter}
                    onDragLeave={dragLeave}
                    onDrop={(e) => fileDropImage(e, 1)}
                    className="shadow-[0_4px_5px_1px_rgba(173, 173, 173, 0.1)] bg-[#F3EBF2] border-[1.5px] border-dashed border-primary-light flex items-center justify-center w-[103px] mr-3"
                  >
                    <label htmlFor="back_cover">
                      <svg
                        width="60"
                        height="44"
                        viewBox="0 0 60 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30 16.2C28.8181 16.2 27.6478 16.4095 26.5558 16.8166C25.4639 17.2236 24.4718 17.8203 23.636 18.5724C22.8003 19.3246 22.1374 20.2175 21.6851 21.2003C21.2328 22.183 21 23.2363 21 24.3C21 25.3637 21.2328 26.417 21.6851 27.3997C22.1374 28.3825 22.8003 29.2754 23.636 30.0276C24.4718 30.7797 25.4639 31.3764 26.5558 31.7834C27.6478 32.1905 28.8181 32.4 30 32.4C32.3869 32.4 34.6761 31.5466 36.364 30.0276C38.0518 28.5085 39 26.4483 39 24.3C39 22.1517 38.0518 20.0915 36.364 18.5724C34.6761 17.0534 32.3869 16.2 30 16.2ZM54 8.1H46.8C46.2818 8.07873 45.7818 7.92177 45.3613 7.64838C44.9409 7.37499 44.6182 6.99707 44.433 6.561L42.57 1.5363C42.3835 1.10071 42.06 0.723462 41.6391 0.450634C41.2182 0.177806 40.7182 0.0212171 40.2 0H19.8C18.81 0 17.742 0.6912 17.433 1.5336L15.567 6.561C15.3815 6.99688 15.0587 7.37461 14.6383 7.64795C14.2179 7.92129 13.7181 8.07839 13.2 8.1H6C2.7 8.1 0 10.53 0 13.5V37.8C0 40.77 2.7 43.2 6 43.2H54C57.3 43.2 60 40.77 60 37.8V13.5C60 10.53 57.3 8.1 54 8.1ZM30 37.8C26.0218 37.8 22.2064 36.3777 19.3934 33.8459C16.5804 31.3142 15 27.8804 15 24.3C15 20.7196 16.5804 17.2858 19.3934 14.7541C22.2064 12.2223 26.0218 10.8 30 10.8C33.9782 10.8 37.7936 12.2223 40.6066 14.7541C43.4196 17.2858 45 20.7196 45 24.3C45 27.8804 43.4196 31.3142 40.6066 33.8459C37.7936 36.3777 33.9782 37.8 30 37.8ZM52.5 16.74C51.943 16.74 51.4089 16.5409 51.0151 16.1864C50.6213 15.832 50.4 15.3513 50.4 14.85C50.4 14.3487 50.6213 13.868 51.0151 13.5136C51.4089 13.1591 51.943 12.96 52.5 12.96C53.057 12.96 53.5911 13.1591 53.9849 13.5136C54.3787 13.868 54.6 14.3487 54.6 14.85C54.6 15.3513 54.3787 15.832 53.9849 16.1864C53.5911 16.5409 53.057 16.74 52.5 16.74Z"
                          fill="#702963"
                          fillOpacity="0.17"
                        />
                      </svg>
                    </label>
                    <input
                      id="back_cover"
                      onChange={(e) =>
                        setMetaData((prevState) => {
                          prevState.bookCover[1] = e.target.files[0];
                          return { ...prevState };
                        })
                      }
                      type="file"
                      className="hidden"
                    />
                  </div>
                )}
              </div>
            )}

            <div className="flex items-center mt-7">
              <label
                tool-tip='If "on" this will enable readers to print a specific page in this book'
                htmlFor="printedBookAvailable"
                className="text-heading-false font-semibold"
              >
                Allow Print
                <span className="text-tertiary-dark">*</span>
              </label>
              <input
                checked={metaData.isPrintedBookAvailable}
                onChange={(e) => {
                  setMetaData((prevState) => ({
                    ...prevState,
                    isPrintedBookAvailable: e.target.checked
                  }));
                }}
                className="w-0 h-0"
                type="checkbox"
                id="printedBookAvailable"
              />
              <div
                data-tip="By Enabling this, users will be allowed to take print out of the page they are reading"
                className={`transition ${
                  !metaData.isPrintedBookAvailable
                    ? " bg-[#d1d1d1]"
                    : "bg-primary-light"
                } ml-4 mt-1 trans flex items-center w-[37px] h-4 rounded-[30px]`}
                onClick={() => {
                  setMetaData((prevState) => ({
                    ...prevState,
                    isPrintedBookAvailable: !prevState.isPrintedBookAvailable
                  }));
                }}
              >
                <div
                  className={`transition ${
                    !metaData.isPrintedBookAvailable
                      ? "translate-x-0"
                      : "translate-x-[20px]"
                  } bg-primary-white w-[18px] h-[18px] border-[0.8px] border-[rgba(0,0,0,0.36)] border-solid rounded-full`}
                ></div>
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* {metaData.isPrintedBookAvailable && (
                <div className="flex flex-col">
                  <label
                    htmlFor="printedBookCost"
                    className="text-heading-false font-semibold"
                  >
                    Printed Book Price
                    <span className="text-tertiary-dark">*</span>
                  </label>
                  <input
                    className="bg-input text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                    id="printedBookCost"
                    name="printedBookCost"
                    type="text"
                    value={metaData.printedBookCost}
                    placeholder="Enter book price"
                    onChange={handleChangeText}
                  />
                </div>
              )} */}

              <div className="flex flex-col my-6">
                <label
                  htmlFor="eBookPrice"
                  className="text-heading-false font-semibold"
                >
                  E-Book Price (in Rs)
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="eBookPrice"
                  name="eBookPrice"
                  type="text"
                  value={metaData.eBookPrice}
                  placeholder="Enter EBook Price"
                  onChange={handleChangeText}
                />
              </div>
              <div className="flex flex-col my-6">
                <label
                  htmlFor="eBookPrice"
                  className="text-heading-false font-semibold"
                >
                  Hard Book Price (in Rs)
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="hardbookPrice"
                  name="hardbookPrice"
                  type="text"
                  value={metaData.hardbookPrice}
                  placeholder="Enter Hard book Price"
                  onChange={handleChangeText}
                />
              </div>
            </div>

            <div className="flex justify-between items-center">
              {/* <div className="flex flex-col my-6">
                <label
                  htmlFor="pageNoStartsAt"
                  className="text-heading-false font-semibold flex items-start"
                >
                  Page number starts at<span className="text-tertiary-dark" >*</span>
                  <div style={{ marginTop: -20, marginLeft: 5, position: 'relative' }} >
                    <span
                      onMouseEnter={(e) =>
                        setHover((prevState) => ({
                          ...prevState,
                          startsAt: true,
                        }))
                      }
                      className="ml-1"

                    >
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 18C12.6522 18 15.1957 17.0518 17.0711 15.364C18.9464 13.6761 20 11.3869 20 9C20 6.61305 18.9464 4.32387 17.0711 2.63604C15.1957 0.948212 12.6522 0 10 0C7.34784 0 4.8043 0.948212 2.92893 2.63604C1.05357 4.32387 0 6.61305 0 9C0 11.3869 1.05357 13.6761 2.92893 15.364C4.8043 17.0518 7.34784 18 10 18ZM11.1625 7.4115L9.9125 12.7046C9.825 13.0871 9.94875 13.3043 10.2925 13.3043C10.535 13.3043 10.9012 13.2255 11.15 13.0275L11.04 13.4955C10.6812 13.8848 9.89 14.1683 9.20875 14.1683C8.33 14.1683 7.95625 13.6935 8.19875 12.6844L9.12125 8.78288C9.20125 8.45325 9.12875 8.334 8.7625 8.25412L8.19875 8.163L8.30125 7.73438L11.1637 7.4115H11.1625ZM10 6.1875C9.66848 6.1875 9.35054 6.06897 9.11612 5.858C8.8817 5.64702 8.75 5.36087 8.75 5.0625C8.75 4.76413 8.8817 4.47798 9.11612 4.267C9.35054 4.05603 9.66848 3.9375 10 3.9375C10.3315 3.9375 10.6495 4.05603 10.8839 4.267C11.1183 4.47798 11.25 4.76413 11.25 5.0625C11.25 5.36087 11.1183 5.64702 10.8839 5.858C10.6495 6.06897 10.3315 6.1875 10 6.1875Z"
                          fill="#C5C5C5"
                        />
                      </svg>
                    </span>
                    {hover.startsAt && (
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="p-3 absolute top-0 left-1 w-[276px] h-fit border-[0.5px] border-solid border-[rgba(182,182,182,0.33)] bg-[#fbfafb]"
                      >
                        <span className="absolute top-2 -left-3"></span>
                        <p className="text-secondary-light text-[13px] font-medium text-left mb-2">
                          Page Number where the chapter of the book begins.
                        </p>

                        <button
                          onClick={(e) => {
                            e.preventDefault()
                            setHover((prevState) => ({
                              ...prevState,
                              startsAt: false,
                            }))
                          }
                          }
                          className="absolute top-2 right-2"
                        >
                          <svg
                            width="5"
                            height="5"
                            viewBox="0 0 5 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.80964 4.82838C4.69011 4.93643 4.528 4.99714 4.35897 4.99714C4.18994 4.99714 4.02783 4.93643 3.9083 4.82838L2.50027 3.37344L1.09223 4.8279C1.03322 4.88212 0.962925 4.92524 0.885391 4.95478C0.807858 4.98432 0.724623 4.99969 0.640487 5C0.556352 5.00031 0.472981 4.98555 0.395184 4.95659C0.317387 4.92762 0.246703 4.88502 0.18721 4.83123C0.127716 4.77745 0.0805912 4.71354 0.048552 4.64321C0.0165128 4.57288 0.000193788 4.4975 0.00053638 4.42144C0.000878972 4.34538 0.0178763 4.27013 0.050548 4.20003C0.0832197 4.12994 0.130919 4.06638 0.190895 4.01304L1.65576 2.50048L0.190364 0.986961C0.130388 0.933616 0.0826886 0.870062 0.0500169 0.799967C0.0173452 0.729872 0.000347876 0.654623 5.28423e-06 0.578559C-0.000337307 0.502495 0.0159817 0.427123 0.0480209 0.35679C0.0800601 0.286457 0.127185 0.222554 0.186679 0.168769C0.246172 0.114983 0.316856 0.0723792 0.394653 0.0434138C0.47245 0.0144485 0.555821 -0.000304946 0.639956 4.77726e-06C0.724092 0.000314501 0.807327 0.0156811 0.88486 0.0452183C0.962394 0.0747555 1.03269 0.117879 1.0917 0.1721L2.50027 1.62752L3.9083 0.1721C3.96731 0.117879 4.03761 0.0747555 4.11514 0.0452183C4.19267 0.0156811 4.27591 0.000314501 4.36004 4.77726e-06C4.44418 -0.000304946 4.52755 0.0144485 4.60535 0.0434138C4.68314 0.0723792 4.75383 0.114983 4.81332 0.168769C4.87281 0.222554 4.91994 0.286457 4.95198 0.35679C4.98402 0.427123 5.00034 0.502495 4.99999 0.578559C4.99965 0.654623 4.98265 0.729872 4.94998 0.799967C4.91731 0.870062 4.86961 0.933616 4.80964 0.986961L3.34477 2.50048L4.80964 4.01304C4.8689 4.06655 4.91591 4.1301 4.94798 4.20005C4.98006 4.27001 4.99657 4.34499 4.99657 4.42071C4.99657 4.49643 4.98006 4.57141 4.94798 4.64136C4.91591 4.71132 4.8689 4.77487 4.80964 4.82838Z"
                              fill="black"
                              fill-opacity="0.53"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                </label>
                <input
                  className="bg-input focus:outline-none text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="pageNoStartsAt"
                  name="pageNoStartsAt"
                  type="text"
                  value={metaData.pageNoStartsAt}
                  placeholder="Page number starts at"
                  onChange={handleChangeText}
                />
              </div> */}
            </div>

            {metaData.additionalField.enable ? (
              <div className="flex flex-col relative">
                <ReactTooltip
                  place="right"
                  backgroundColor="#737272"
                  type="success"
                  effect="solid"
                  offset={{ bottom: 0 }}
                  delayShow="200"
                />
                <input
                  value={metaData.additionalField.name}
                  onChange={(e) =>
                    setMetaData((prevState) => ({
                      ...prevState,
                      additionalField: {
                        ...prevState.additionalField,
                        name: e.target.value
                      }
                    }))
                  }
                  htmlFor="printedBookCost"
                  className="text-heading-false font-semibold w-40"
                  placeholder="Enter Field Name"
                />
                <input
                  className="bg-input text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10"
                  id="printedBookCost"
                  type="text"
                  placeholder="Enter Field Value"
                  value={metaData.additionalField.value}
                  onChange={(e) =>
                    setMetaData((prevState) => ({
                      ...prevState,
                      additionalField: {
                        ...prevState.additionalField,
                        value: e.target.value
                      }
                    }))
                  }
                />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setMetaData((prevState) => ({
                      ...prevState,
                      additionalField: {
                        ...prevState.additionalField,
                        enable: false,
                        name: "",
                        value: ""
                      }
                    }));
                  }}
                  className="bg-[#ebe8e8] flex justify-center items-center rounded-full w-[34px] h-[34px] absolute left-[350px] top-10"
                  data-tip="Delete"
                >
                  <svg
                    width="18"
                    height="21"
                    viewBox="0 0 18 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8 3.80078C10.8 3.32339 10.6104 2.86555 10.2728 2.52799C9.93523 2.19042 9.47739 2.00078 9 2.00078C8.52261 2.00078 8.06477 2.19042 7.72721 2.52799C7.38964 2.86555 7.2 3.32339 7.2 3.80078H6C6 3.00513 6.31607 2.24207 6.87868 1.67946C7.44129 1.11685 8.20435 0.800781 9 0.800781C9.79565 0.800781 10.5587 1.11685 11.1213 1.67946C11.6839 2.24207 12 3.00513 12 3.80078H17.4C17.5591 3.80078 17.7117 3.864 17.8243 3.97652C17.9368 4.08904 18 4.24165 18 4.40078C18 4.55991 17.9368 4.71252 17.8243 4.82505C17.7117 4.93757 17.5591 5.00078 17.4 5.00078H16.7352L15.18 18.4768C15.1123 19.0617 14.8319 19.6012 14.3923 19.9929C13.9527 20.3845 13.3844 20.6009 12.7956 20.6008H5.2044C4.61562 20.6009 4.04735 20.3845 3.6077 19.9929C3.16806 19.6012 2.88771 19.0617 2.82 18.4768L1.2636 5.00078H0.6C0.459569 5.00083 0.323571 4.95161 0.215689 4.86171C0.107808 4.77181 0.0348774 4.64692 0.00959988 4.50878L0 4.40078C0 4.24165 0.0632142 4.08904 0.175736 3.97652C0.288258 3.864 0.44087 3.80078 0.6 3.80078H10.8ZM15.5256 5.00078H2.4732L4.0116 18.3388C4.04547 18.6313 4.18573 18.9012 4.40567 19.097C4.62562 19.2929 4.90991 19.401 5.2044 19.4008H12.7956C13.0899 19.4007 13.3739 19.2924 13.5936 19.0966C13.8133 18.9008 13.9534 18.6311 13.9872 18.3388L15.5256 5.00078ZM7.2 8.00078C7.494 8.00078 7.74 8.18678 7.7904 8.43158L7.8 8.52638V15.8764C7.8 16.1656 7.5312 16.4008 7.2 16.4008C6.906 16.4008 6.66 16.2148 6.6096 15.97L6.6 15.8752V8.52758C6.6 8.23718 6.8688 8.00198 7.2 8.00198V8.00078ZM10.8 8.00078C11.094 8.00078 11.34 8.18678 11.3904 8.43158L11.4 8.52638V15.8764C11.4 16.1656 11.1312 16.4008 10.8 16.4008C10.506 16.4008 10.26 16.2148 10.2096 15.97L10.2 15.8752V8.52758C10.2 8.23718 10.4688 8.00198 10.8 8.00198V8.00078Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setMetaData((prevState) => ({
                    ...prevState,
                    additionalField: {
                      ...prevState.additionalField,
                      enable: true
                    }
                  }));
                }}
                className="text-montserrat leading-[22px] font-semibold text-[18px] text-secondary-dark w-[270px] h-[12] bg-[#f9f6f6] border-1 border-solid border-[#eee] py-2 px-3 flex justify-evenly items-center"
              >
                <span>
                  <svg
                    width="33"
                    height="31"
                    viewBox="0 0 33 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.6607 0.125C12.3576 0.172817 8.24536 1.76852 5.20238 4.57127C2.1594 7.37402 0.426916 11.1616 0.375 15.125C0.426916 19.0884 2.1594 22.876 5.20238 25.6787C8.24536 28.4815 12.3576 30.0772 16.6607 30.125C20.9638 30.0772 25.0761 28.4815 28.1191 25.6787C31.162 22.876 32.8945 19.0884 32.9464 15.125C32.8945 11.1616 31.162 7.37402 28.1191 4.57127C25.0761 1.76852 20.9638 0.172817 16.6607 0.125ZM25.9668 16.1964H17.824V23.6964H15.4974V16.1964H7.35459V14.0536H15.4974V6.55357H17.824V14.0536H25.9668V16.1964Z"
                      fill="#D1D1D1"
                    />
                  </svg>
                </span>
                Add Additional field
              </button>
            )}

            <div className="flex mt-8 justify-end items-center">
              {validateStep4 ? (
                <BtnSmallDisabled disabled style={{ cursor: "not-allowed" }}>
                  Next
                </BtnSmallDisabled>
              ) : (
                <BtnSmall
                  onClick={(e) => {
                    e.preventDefault();
                    !validateStep4 && setCurrentStep(5);
                  }}
                >
                  Next
                </BtnSmall>
              )}
            </div>
          </form>
        );
        break;

      /// 4!!! end step -------------------------------------------------
      // change in 5 div width 902 to 950px
      case 5:
        setRenderedStep(
          <div className="overflow-x-hidden flex flex-col w-[950px] h-[370px] mx-auto border-[1.5px] border-solid border-primary-dark-10 scrollbar scrollbar-thumb-thumb scrollbar-track-track">
            <h2 className="text-heading text-h1 font-semibold text-left mt-4 pl-6 mb-0">
              Summary
            </h2>
            <div className="flex  p-4  w-full h-[370px] mt-3 mx-auto ">
              {/* <div className="w-1/3 ">
                <div className="relative h-[361px] w-[278px] mx-auto drop-shadow-[15px_15px_10px_rgba(0,0,0,0.25)]">
                  <img src={Book} alt="book" />
                  <button className="rounded-md w-[133px] h-8 absolute bottom-12 left-[68px] bg-[#979797] text-primary-white ">
                    Page 1 of {metaData.noOfPages}
                  </button>
                </div>
              </div> */}
              {/*<div className="w-2/3 px-10 pt-4 text-left ">
                 <p className="text-secondary-light text-h5 text-justify mb-6">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. At
                  aliquet ut facilisi nulla mauris iopsum. Pipsum dolor sit
                  ametre, consectetur adipiscing elit. At aliquet ut facilisi
                  nulla mauris.
                </p> */}
              {/* <div className="flex mb-3">
                  <p className="text-h5 text-secondary-dark font-semibold mr-16">
                    No. of pages
                  </p>
                  <h4 className="text-h5 text-heading font-semibold">
                    {metaData.noOfPages}
                  </h4>
                </div> */}
              {/* <div className="flex mb-3">
                  <p className="text-h5 text-secondary-dark font-semibold mr-9 ">
                    Validity package
                  </p>
                  <h4 className="text-h5 text-heading font-semibold">
                    {filterData} year
                  </h4>
                </div> */}
              {/* <div className="flex mb-3">
                  <p className="text-h5 text-secondary-dark font-semibold mr-[35px] ">
                    Conversion time
                  </p>
                  <h4 className="text-h5 text-heading font-semibold">
                    16 days
                  </h4>
                </div> */}
              {/* <div className="flex ">
                  <p className="text-h5 text-secondary-dark font-semibold mr-8 ">
                    Conversion price
                  </p>
                  <h4 className="text-h5 text-heading font-semibold">
                    {parseInt(uploadedBookData.hostingCharge) *
                      parseInt(filterData) +
                      parseFloat(uploadedBookData.conversionCharge)}
                    <span className="text-secondary-light text-sm font-[400]">
                      Tokens
                    </span>{" "}
                  </h4>
                </div> 
              </div>*/}
            </div>
            <div className="p-6  w-[902px] h-[370px] mt-0 mx-auto ">
              {/* <h2 className="text-heading text-h1 font-semibold text-left mb-8">
                Book details
              </h2> */}
              <div className="w-full flex justify-between items-center mb-6">
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="book_title"
                  >
                    Book Title<span className="text-tertiary-dark">*</span>
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.title}
                  </p>
                </div>
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="isbn"
                  >
                    ISBN
                  </label>

                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.ISBN}
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-between items-center mb-6">
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="author"
                  >
                    Edition<span className="text-tertiary-dark">*</span>
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.edition}
                  </p>
                </div>
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="author"
                  >
                    No. of pages<span className="text-tertiary-dark">*</span>
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.noOfPages}
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-between items-center mb-6">
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="author"
                  >
                    Allow Print
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.isPrintedBookAvailable ? "Yes" : "No"}
                  </p>
                </div>
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="author"
                  >
                    Validity package
                    <span className="text-tertiary-dark">*</span>
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData?.validity} year
                  </p>
                </div>
              </div>

              <div className="w-full flex justify-between items-center mb-6">
                <div className="flex flex-col">
                  <p className="text-heading-false font-semibold">
                    Authors<span className="text-tertiary-dark">*</span>
                  </p>
                  <div className="flex items-center h-[52px] mt-2">
                    {metaData.authors.map((item) => (
                      <div
                        key={item.id}
                        className="flex rounded-[2px] border-1 border-[#dadada] justify-center items-center relative mr-3 bg-primary-white px-6 h-[38px]"
                      >
                        <p className="text-center font-semibold text-montserrat leading-[20px] capitalize text-[#8692a6]">
                          {item.bookAuthorName}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex flex-col w-[38.5%]">
                  <p className="text-heading-false font-semibold">
                    Publications<span className="text-tertiary-dark">*</span>
                  </p>
                  <div className="flex items-center h-[52px] mt-2">
                    {metaData.publications.map((item) => (
                      <div
                        key={item.id}
                        className="min-w-[100px] flex rounded-[2px] border-1 border-[#dadada] justify-center items-center relative mr-3 bg-primary-white px-6 h-[38px]"
                      >
                        <p className="text-center font-semibold text-montserrat leading-[20px] capitalize text-[#8692a6]">
                          {item.bookPublicationName}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <p className="text-heading-false font-semibold">
                Category<span className="text-tertiary-dark">*</span>
              </p>
              <div className="flex items-center h-[52px] mt-2 mb-6">
                {metaData.category.map((item) => (
                  <div
                    key={item.id}
                    className="flex justify-center items-center relative mr-3 bg-[#939CECC7] w-[122px] h-[38px]"
                  >
                    <p className="text-center text-primary-white">
                      {item.bookCategoryName}
                    </p>
                  </div>
                ))}
              </div>

              <label
                htmlFor="short_description"
                className="text-heading-false font-semibold"
              >
                Short Description
              </label>
              <p className="text-h5 w-full text-justify p-4 pl-0 text-secondary-light font-semibold mt-2 mb-6">
                {metaData.shortDescription}
              </p>

              <label
                htmlFor="long_description"
                className="text-heading-false font-semibold"
              >
                Long Description
              </label>
              <p className="text-h5 w-full text-justify p-4 pl-0 text-secondary-light font-semibold mt-2 mb-6">
                {metaData.longDescription}
              </p>

              <label className="text-heading-false font-semibold">
                Covers<span className="text-tertiary-dark">*</span>
              </label>

              <div className="h-[133px] mt-4 mb-2 flex">
                {metaData.bookCover[0] && (
                  <div className="shadow-[0_4px_5px_1px_rgba(173, 173, 173, 0.1)] bg-[#F3EBF2] border-[1.5px] border-dashed border-primary-light flex items-center justify-center w-[103px] mr-3">
                    <img
                      className="object-cover h-full w-full"
                      src={URL.createObjectURL(metaData.bookCover[0])}
                      alt="front book cover"
                      onLoad={onImageLoad}
                    />
                  </div>
                )}
                {metaData.bookCover[1] && (
                  <div className="shadow-[0_4px_5px_1px_rgba(173, 173, 173, 0.1)] bg-[#F3EBF2] border-[1.5px] border-dashed border-primary-light flex items-center justify-center w-[103px] mr-3">
                    <img
                      className="object-cover h-full w-full"
                      src={URL.createObjectURL(metaData.bookCover[1])}
                      alt="book cover back"
                    />
                  </div>
                )}
              </div>

              {/* {metaData.isPrintedBookAvailable && (
                <div className="flex my-8 items-center justify-between">
                  <div className="flex flex-col">
                    <label
                      className="text-heading-false font-semibold"
                      htmlFor="book_title"
                    >
                      Printed book available
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <p className=" flex items-center bg-input text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10">
                      Yes
                    </p>
                  </div>
                  <div className="flex flex-col">
                    <label
                      className="text-heading-false font-semibold"
                      htmlFor="book_title"
                    >
                      Printed book price
                      <span className="text-tertiary-dark">*</span>
                    </label>
                    <p className="flex items-center bg-input text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10">
                      {metaData.printedBookCost}
                    </p>
                  </div>
                </div>
              )} */}
              <div className="mt-5 flex justify-between mb-3  w-full">
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="book_title"
                  >
                    E-book price
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.eBookPrice}
                  </p>
                </div>

                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="book_title"
                  >
                    Hard Book price
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.hardbookPrice}
                  </p>
                </div>
              </div>
              {metaData.additionalField.enable && (
                <div className="flex flex-col">
                  <label
                    className="text-heading-false font-semibold"
                    htmlFor="book_title"
                  >
                    {metaData.additionalField.name}
                  </label>
                  <p className="text-secondary-light text-h5  mt-2 w-[333px] h-[52px]">
                    {metaData.additionalField.value}
                  </p>
                </div>
                // <div className="flex flex-col my-8">
                //   <label
                //     className="text-heading-false font-semibold"
                //     htmlFor="book_title"
                //   >
                //     {metaData.additionalField.name}
                //     <span className="text-tertiary-dark">*</span>
                //   </label>
                //   <p className="flex items-center bg-input text-heading-false text-h5 w-[333px] h-[52px] pl-3 mt-2 border-[1.5px] border-solid border-primary-dark-10">
                //     {metaData.additionalField.value}
                //   </p>
                // </div>
              )}

              <div className="flex items-center justify-between pb-4">
                <div>
                  <button
                    onClick={() => setCurrentStep(4)}
                    className=" text-tertiary-dark font-bold text-[18px] gap-1 underline  flex justify-center items-center "
                  >
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.24165 1.15081C6.3189 1.23562 6.38019 1.33635 6.42201 1.44724C6.46383 1.55813 6.48535 1.67701 6.48535 1.79706C6.48535 1.91712 6.46383 2.03599 6.42201 2.14689C6.38019 2.25778 6.3189 2.35851 6.24165 2.44331L3.00832 5.99998L6.24165 9.55665C6.39746 9.72804 6.485 9.9605 6.485 10.2029C6.485 10.4453 6.39746 10.6778 6.24165 10.8491C6.08583 11.0205 5.8745 11.1168 5.65415 11.1168C5.43379 11.1168 5.22246 11.0205 5.06665 10.8491L1.24165 6.64165C1.16439 6.55684 1.1031 6.45611 1.06129 6.34522C1.01947 6.23433 0.997945 6.11545 0.997945 5.9954C0.997945 5.87534 1.01947 5.75647 1.06129 5.64557C1.1031 5.53468 1.16439 5.43395 1.24165 5.34915L5.06665 1.14165C5.38331 0.793313 5.91665 0.793313 6.24165 1.15081Z"
                        fill="#702963"
                      />
                    </svg>
                    Back
                  </button>
                </div>
                <div className="flex flex-row gap-2">
                  <BtnSmallWhite
                    onClick={() => {
                      // setModals((prevState) => ({
                      //   ...prevState,
                      //   uploadByBook: false,
                      // }));
                      // setShowUploadBook(false)
                      setCancelNewBook(true);
                    }}
                  >
                    Cancel
                  </BtnSmallWhite>
                  <span className="mx-3"></span>
                  <BtnSmall onClick={handleActivate}>
                    {miniLoader ? (
                      <div className="flex">
                        <svg
                          className="animate-spin ml-1 mr-3 h-5 w-5 "
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            class="opacity-20"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          ></circle>
                          <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Processing...
                      </div>
                    ) : (
                      "Activate"
                    )}
                  </BtnSmall>
                </div>
              </div>
            </div>
          </div>
        );
        break;

      default:
        break;
    }
  }, [
    resend,
    currentStep,
    paid,
    metaData,
    category,
    author,
    publication,
    hover,
    uploading,
    otps,
    showCategorySuggestion,
    filterData,
    filterSort,
    metaData.noOfPages
  ]);
  useEffect(() => {
    handleSessionTokens();
  }, []);
  /*==================================== stepper ends============================*/
  return (
    <Page active="wallet">
      <Navbar />
      <div
        className={`block px-4 flex lg:hidden justify-between items-center w-screen `}
      >
        <h1 className=" flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
          <span onClick={() => navigate(-1)} className=" mr-3">
            <svg
              width="12"
              height="20"
              viewBox="0 0 12 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                fill="#702963"
              />
            </svg>
          </span>
          New Book Conversion
        </h1>
        <div className="flex lg:hidden items-center">
          <button className="mr-5">
            <svg
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                stroke="#702963"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button>
            <svg
              width="28"
              height="24"
              viewBox="0 0 28 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                fill="#702963"
              />
            </svg>
          </button>
        </div>
      </div>
      <h1 className="hidden lg:block text-h1 text-heading text-left font-semibold">
        New Book Conversion
      </h1>

      <div className="hidden lg:flex justify-between items-center my-6">
        <h2 className="text-h2 text-heading text-left font-semibold">
          Draft Conversions
        </h2>
        <button
          onClick={() =>
            setModals((prevState) => ({ ...prevState, addNew: true }))
          }
          style={{
            background:
              "linear-gradient(180deg,rgba(112, 41, 99, 1), rgba(112, 41, 99, .76) )",
            color: "white"
          }}
          className="border-1 border-solid border-[#CACACA] w-[225px] h-[54px] hover:border-primary-dark text-h5 text-tertiary-dark  font-semibold flex justify-evenly items-center rounded-[3px] shadow "
        >
          <svg
            width="25"
            height="23"
            viewBox="0 0 25 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.25 0C9.01323 0.0362614 5.92003 1.24634 3.63112 3.37175C1.34221 5.49717 0.0390507 8.36943 0 11.375C0.0390507 14.3806 1.34221 17.2528 3.63112 19.3782C5.92003 21.5037 9.01323 22.7137 12.25 22.75C15.4868 22.7137 18.58 21.5037 20.8689 19.3782C23.1578 17.2528 24.4609 14.3806 24.5 11.375C24.4609 8.36943 23.1578 5.49717 20.8689 3.37175C18.58 1.24634 15.4868 0.0362614 12.25 0ZM19.25 12.1875H13.125V17.875H11.375V12.1875H5.25V10.5625H11.375V4.875H13.125V10.5625H19.25V12.1875Z"
              fill="white"
            />
          </svg>
          Convert a New Book
        </button>
      </div>
      <div className="bg-[#fbfafb] lg:hidden mx-3 mt-12 mb-10 p-3 border-1 border-solid border-[rgba(112,41,99,0.19)] h-[92px]">
        <p className="text-justify font-semibold text-[15px] text-secondary-light text-montserrat mb-1 leading-[19px]">
          You can't add new books on mobile. lorem ipsum dolor sit amet iosum
        </p>
        <p className="text-tertiary-dark t-[15px] font-semibold text-montserrat">
          Please go back to website
        </p>
      </div>
      <h2 className="px-4 lg:hidden text-montserrat font-semibold leading-[20px] my-6 text-secondary-dark">
        Ongoing conversions
      </h2>
      <div className="px-4 mb-24 lg:mb-0 lg:px-0 w-full gap-4 gap-y-6 lg:gap-y-6 lg:gap-6 my-8 grid grid-cols-[repeat(2,_minmax(186px,_1fr))] lg:flex lg:justify-start lg:flex-wrap">
        {books.length > 0 ? (
          books?.map((book) => (
            <div
              key={book.id}
              onClick={() => {
                !book.isPaid && book.epubUrl == null && handleGotoForm(book);
                handleGotoForm(book);
              }}
              className="relative lg:w-[260px] h-[300px] lg:h-[351px] border-1 border-solid border-primary-dark-20 scale-1 lg:hover:scale-105 lg:transition lg:duration-600 hover:ease-in"
            >
              <div className="w-full h-[70%] lg:h-[70%] bg-neutral-10 relative">
                {/* <div className="rounded-full border-l-primary-white absolute top-[calc(50%-17px)] left-[calc(50%-17px)] lg:top-[calc(50%-32px)] lg:left-[calc(50%-32px)] w-[35px] h-[35px] lg:w-[65px] lg:h-[65px] border-[6px] border-solid border-primary-dark-10 "></div>
                 */}
                <div className="flex w-full h-full justify-center items-center ">
                  <p className="text-[38px] font-[800] bg-clip-text text-[#fff0] bg-gradient-to-r from-[#787676] to-[#7876761c] [from-[#702963] to-[#7029630c]] ">
                    BOOK <br /> UNDER
                    <br /> CONVERSION
                  </p>
                </div>
                <div className="absolute top-1 left-1 ">
                  <svg
                    width="77"
                    height="27"
                    viewBox="0 0 77 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 2C0 0.895431 0.895431 0 2 0H73.708C75.4074 0 76.3324 1.98518 75.2394 3.28638L67.5 12.5L75.7023 23.827C76.6599 25.1494 75.7151 27 74.0824 27H2C0.89543 27 0 26.1046 0 25V2Z"
                      fill="#FFD600"
                      fill-opacity="0.9"
                    />
                  </svg>
                  <p className="absolute left-[20px] top-[2px] font-semibold text-heading text-p1 text-center">
                    Draft
                  </p>
                </div>
              </div>
              <div className="flex flex-col justify-between w-full h-[30%] lg:h-[30%] p-3 lg:p-2">
                <p className="mt-1 py-1 whitespace-nowrap text-ellipsis overflow-hidden text-[18px] lg:text-[19px] mb-4 lg:mb-0 text-heading font-semibold text-left leading-[18px] lg:leading-none">
                  {book.title}
                </p>
                {/* <div className="hidden lg:flex justify-between items-center mt-4">
                <p className="text-secondary-dark font-semibold">
                  {book.author}
                </p>
                <p className="text-heading font-semibold text-h5">
                  {" "}
                  &#8377;{book.price}
                </p>
              </div> */}
                <p className="mb-5 text-secondary-dark font-semibold text-montserrat leading-[20px]">
                  {book?.isPaid
                    ? notifySound
                      ? "Ongoing Conversion..."
                      : "Book Converted Successfully. Proceed to Next Steps"
                    : "Unpaid Book"}
                </p>
              </div>
              <button
                onClick={(e) => {
                  // deletedraft(book.id);
                  setModals((prev) => ({ ...prev, draftDelete: true }));
                  setDeleteId(book?.id);
                  e.stopPropagation();
                }}
                className="absolute top-2 right-2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="[#b4b4b4]"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.8 4.7998C13.8 4.32241 13.6104 3.86458 13.2728 3.52701C12.9352 3.18945 12.4774 2.9998 12 2.9998C11.5226 2.9998 11.0648 3.18945 10.7272 3.52701C10.3896 3.86458 10.2 4.32241 10.2 4.7998H9C9 4.00416 9.31607 3.24109 9.87868 2.67848C10.4413 2.11588 11.2044 1.7998 12 1.7998C12.7956 1.7998 13.5587 2.11588 14.1213 2.67848C14.6839 3.24109 15 4.00416 15 4.7998H20.4C20.5591 4.7998 20.7117 4.86302 20.8243 4.97554C20.9368 5.08806 21 5.24067 21 5.3998C21 5.55893 20.9368 5.71155 20.8243 5.82407C20.7117 5.93659 20.5591 5.9998 20.4 5.9998H19.7352L18.18 19.4758C18.1123 20.0607 17.8319 20.6003 17.3923 20.9919C16.9527 21.3835 16.3844 21.5999 15.7956 21.5998H8.2044C7.61562 21.5999 7.04735 21.3835 6.6077 20.9919C6.16806 20.6003 5.88771 20.0607 5.82 19.4758L4.2636 5.9998H3.6C3.45957 5.99985 3.32357 5.95064 3.21569 5.86074C3.10781 5.77084 3.03488 5.64594 3.0096 5.5078L3 5.3998C3 5.24067 3.06321 5.08806 3.17574 4.97554C3.28826 4.86302 3.44087 4.7998 3.6 4.7998H13.8ZM18.5256 5.9998H5.4732L7.0116 19.3378C7.04547 19.6303 7.18573 19.9002 7.40567 20.096C7.62562 20.2919 7.90991 20.4 8.2044 20.3998H15.7956C16.0899 20.3997 16.3739 20.2915 16.5936 20.0956C16.8133 19.8998 16.9534 19.6301 16.9872 19.3378L18.5256 5.9998ZM10.2 8.9998C10.494 8.9998 10.74 9.1858 10.7904 9.4306L10.8 9.5254V16.8754C10.8 17.1646 10.5312 17.3998 10.2 17.3998C9.906 17.3998 9.66 17.2138 9.6096 16.969L9.6 16.8742V9.5266C9.6 9.2362 9.8688 9.001 10.2 9.001V8.9998ZM13.8 8.9998C14.094 8.9998 14.34 9.1858 14.3904 9.4306L14.4 9.5254V16.8754C14.4 17.1646 14.1312 17.3998 13.8 17.3998C13.506 17.3998 13.26 17.2138 13.2096 16.969L13.2 16.8742V9.5266C13.2 9.2362 13.4688 9.001 13.8 9.001V8.9998Z"
                    fill="#702963"
                  />
                </svg>
              </button>
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-[70%]">
            <p className="mt-[170px] text-secondary-light text-montserrat text-center font-semibold leading-[29px] text-h3">
              You do not have any Books in Draft/Ongoing Conversion State
            </p>
          </div>
        )}
      </div>

      {showUploadBook && (
        <DialogBox height={true} show={modals.addNew}>
          <div className="bg-primary-white flex flex-col justify-between relative w-pop-up h-fit gap-6 p-8">
            <h4 className="text-h4 mb-3 text-tertiary-dark font-bold">
              Convert &#38; Add a Book
            </h4>

            <div className="flex flex-col h-16 justify-between">
              <p className="text-secondary-light">
                Please follow the subsequent steps to successfully Upload,
                Convert &#38; Add an Ebook to your publication
              </p>
              {/* ########################ONLY HIDDEN FOR DISPLAY PURPOSES :: FUNCTIONALITY IS OPERATIONAL. DO NOT DELETE########################
              <div className="flex items-center ">
                <input
                  name="radio-1"
                  id="radio-1"
                  type="radio"
                  checked={uploadByBook}
                  onChange={handleUploadType}
                  className="w-4 h-4 rounded-full bg-primary-dark mr-4"
                />
                <label
                  htmlFor="radio-1"
                  className="text-heading font-semibold text-h5"
                >
                  Upload a Book
                </label>
              </div> */}
              {/* <div className="flex items-center">
                <input
                  name="radio-2"
                  type="radio"
                  id="radio-2"
                  checked={!uploadByBook}
                  onChange={handleUploadType}
                  className="w-4 h-4 rounded-full bg-primary-dark mr-4"
                />
                <label
                  htmlFor="radio-2"
                  className="text-heading font-semibold text-h5"
                >
                  Upload a chapter by chapter
                </label>
              </div> */}
            </div>
            <div className="w-full flex justify-end mt-3 text-right">
              <BtnSmall
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    addNew: false,
                    uploadByBook: uploadByBook ? true : false
                  }))
                }
              >
                Continue
              </BtnSmall>
            </div>
            <button
              onClick={() => {
                setModals((prevState) => ({ ...prevState, addNew: false }));
              }}
              className="absolute top-8 right-8"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                  fill="black"
                  fillOpacity="0.53"
                />
              </svg>
            </button>
          </div>
        </DialogBox>
      )}

      <DialogBox show={modals.uploadByBook}>
        <div className="bg-primary-white flex flex-col justify-between relative w-[1090px] p-8">
          <h4 className="text-h4 text-tertiary-dark font-bold">
            Convert a New Book
          </h4>
          <div className="flex justify-between items-center my-12">
            <div className="relative rounded-full w-12 h-12 bg-primary-dark border-2 border-solid border-primary-light flex justify-center items-center">
              <svg
                width="27"
                height="23"
                viewBox="0 0 27 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.833 1.91699H4.94775V21.0837H22.3641V7.66699L15.833 1.91699ZM14.7445 14.3753V18.2087H12.5674V14.3753H9.30185L13.6668 10.542L18.01 14.3753H14.7445ZM14.7445 8.62533V3.35449L20.7314 8.62533H14.7445Z"
                  fill="white"
                />
              </svg>

              <p className="text-heading font-semibold text-p1 absolute -bottom-8 -left-1">
                Upload
              </p>
            </div>
            <div
              style={{
                background:
                  currentStep === 1
                    ? "linear-gradient(90deg, #702963, #fff)"
                    : currentStep > 1
                    ? "#702963"
                    : "#c2c2bd"
              }}
              className="w-progress-chart-1 h-1 bg-primary-dark"
            ></div>
            <div
              className={`relative rounded-full w-12 h-12 ${
                currentStep > 1 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
            >
              <svg
                width="21"
                height="24"
                viewBox="0 0 21 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.06866 0.916992H13.9129L20.0359 6.16699V19.5837C20.0359 19.8931 19.8925 20.1898 19.6374 20.4086C19.3822 20.6274 19.0361 20.7503 18.6752 20.7503H5.06866C4.7078 20.7503 4.36171 20.6274 4.10654 20.4086C3.85136 20.1898 3.70801 19.8931 3.70801 19.5837V2.08366C3.70801 1.77424 3.85136 1.47749 4.10654 1.2587C4.36171 1.03991 4.7078 0.916992 5.06866 0.916992ZM17.9949 6.16699L13.9129 2.66699V5.58366C13.9129 5.73837 13.9846 5.88674 14.1122 5.99614C14.2398 6.10553 14.4128 6.16699 14.5933 6.16699H17.9949ZM16.4349 10.4212C16.5624 10.5306 16.6341 10.679 16.6341 10.8337C16.6341 10.9883 16.5624 11.1367 16.4349 11.2461L10.5113 16.3252L7.30898 13.5794C7.18506 13.4694 7.11648 13.322 7.11803 13.1691C7.11958 13.0161 7.19113 12.8698 7.31727 12.7617C7.44341 12.6535 7.61405 12.5922 7.79243 12.5908C7.97081 12.5895 8.14266 12.6483 8.27097 12.7546L10.5113 14.6755L15.4729 10.4212C15.6005 10.3119 15.7735 10.2505 15.9539 10.2505C16.1343 10.2505 16.3073 10.3119 16.4349 10.4212Z"
                  fill="white"
                />
                <path
                  d="M2.34747 4.41699H0.986816V20.167C0.986816 20.9405 1.3452 21.6824 1.98313 22.2294C2.62107 22.7764 3.48629 23.0837 4.38846 23.0837H17.3147V21.917H4.38846C3.84715 21.917 3.32802 21.7326 2.94526 21.4044C2.5625 21.0762 2.34747 20.6311 2.34747 20.167V4.41699Z"
                  fill="white"
                />
              </svg>

              <p className="text-heading font-semibold text-p1 absolute -bottom-8 -left-8 w-28">
                Accept Charges
              </p>
            </div>
            <div
              style={{
                background:
                  currentStep === 2
                    ? "linear-gradient(90deg, #702963, #fff)"
                    : currentStep > 2
                    ? "#702963"
                    : "#c2c2bd"
              }}
              className="w-progress-chart-1 h-1 bg-primary-dark"
            ></div>
            <div
              className={`relative rounded-full w-12 h-12 ${
                currentStep > 2 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
            >
              {/* <svg
                width="35"
                height="26"
                viewBox="0 0 35 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.1106 3.25H26.1707L24.7647 5.41667H20.1811C20.856 6.045 21.3622 6.78167 21.6574 7.58333H26.1707L24.7647 9.75H21.9527C21.7784 11.1007 21.017 12.3663 19.792 13.3417C18.5669 14.317 16.9501 14.9449 15.2038 15.1233V15.1667H14.2196L22.6557 22.75H19.1407L10.7046 15.1667V13H14.2196C16.6942 13 18.747 11.5917 19.0844 9.75H10.7046L12.1106 7.58333H18.6626C17.8752 6.305 16.188 5.41667 14.2196 5.41667H10.7046L12.1106 3.25Z"
                  fill="white"
                />
              </svg> */}
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7382 10.9526V13.8098C16.7382 15.0479 13.9027 16.6669 10.4049 16.6669C6.90706 16.6669 4.07153 15.0479 4.07153 13.8098V11.4288"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.3374 11.6755C5.12002 12.7688 7.54026 13.7945 10.4047 13.7945C13.9025 13.7945 16.7381 12.265 16.7381 10.9507C16.7381 10.2126 15.8451 9.40404 14.4436 8.83643"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.0238 6.19043V9.04757C14.0238 10.2857 11.1883 11.9047 7.69051 11.9047C4.1927 11.9047 1.35718 10.2857 1.35718 9.04757V6.19043"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.69051 9.03254C11.1883 9.03254 14.0238 7.50302 14.0238 6.18873C14.0238 4.8735 11.1883 3.3335 7.69051 3.3335C4.1927 3.3335 1.35718 4.8735 1.35718 6.18873C1.35718 7.50302 4.1927 9.03254 7.69051 9.03254Z"
                  fill="white"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="text-heading font-semibold text-p1 absolute -bottom-8 left-2">
                Payment
              </p>
            </div>
            <div
              style={{
                background:
                  currentStep === 3
                    ? "linear-gradient(90deg, #702963, #fff)"
                    : currentStep > 3
                    ? "#702963"
                    : "#c2c2bd"
              }}
              className="w-progress-chart-1 h-1 bg-primary-dark"
            ></div>
            <div
              className={`relative rounded-full w-12 h-12 ${
                currentStep > 3 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
            >
              <svg
                width="34"
                height="27"
                viewBox="0 0 34 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.7672 9H7.06775C6.82717 9 6.59644 8.92098 6.42633 8.78033C6.25621 8.63968 6.16064 8.44891 6.16064 8.25V5.25C6.16064 5.05109 6.25621 4.86032 6.42633 4.71967C6.59644 4.57902 6.82717 4.5 7.06775 4.5H19.7672C20.0078 4.5 20.2385 4.57902 20.4086 4.71967C20.5787 4.86032 20.6743 5.05109 20.6743 5.25V8.25C20.6743 8.44891 20.5787 8.63968 20.4086 8.78033C20.2385 8.92098 20.0078 9 19.7672 9ZM7.97485 7.5H18.8601V5.955H7.97485V7.5Z"
                  fill="white"
                />
                <path
                  d="M19.7672 10.5596H7.06775C6.82717 10.5596 6.59644 10.6386 6.42633 10.7792C6.25621 10.9199 6.16064 11.1107 6.16064 11.3096V14.2496C6.16064 14.4485 6.25621 14.6392 6.42633 14.7799C6.59644 14.9206 6.82717 14.9996 7.06775 14.9996H17.3725L20.6743 12.2246V11.3096C20.6743 11.1107 20.5787 10.9199 20.4086 10.7792C20.2385 10.6386 20.0078 10.5596 19.7672 10.5596ZM18.8601 13.4996H7.97485V11.9996H18.8601V13.4996Z"
                  fill="white"
                />
                <path
                  d="M10.7506 23.6325V23.5875L11.0409 22.545H4.34643V3H22.4885V10.6875L24.3027 9.27V2.25C24.3027 2.05109 24.2072 1.86032 24.037 1.71967C23.8669 1.57902 23.6362 1.5 23.3956 1.5H3.43933C3.19875 1.5 2.96803 1.57902 2.79791 1.71967C2.6278 1.86032 2.53223 2.05109 2.53223 2.25V23.25C2.53223 23.4489 2.6278 23.6397 2.79791 23.7803C2.96803 23.921 3.19875 24 3.43933 24H10.6962C10.7036 23.8766 10.7218 23.7538 10.7506 23.6325Z"
                  fill="white"
                />
                <path
                  d="M20.6744 14.3779L19.9668 14.9704C20.1423 14.9405 20.3032 14.8683 20.4292 14.7628C20.5551 14.6574 20.6404 14.5234 20.6744 14.3779Z"
                  fill="white"
                />
                <path
                  d="M6.16064 20.205C6.16064 20.4039 6.25621 20.5947 6.42633 20.7353C6.59644 20.876 6.82717 20.955 7.06775 20.955H11.4581L11.7303 19.98L11.8482 19.5675V19.53H7.97485V18H13.7259L15.5401 16.5H7.06775C6.82717 16.5 6.59644 16.579 6.42633 16.7197C6.25621 16.8603 6.16064 17.0511 6.16064 17.25V20.205Z"
                  fill="white"
                />
                <path
                  d="M31.097 12.5025L28.04 9.97496C27.9044 9.86248 27.7432 9.77324 27.5657 9.71235C27.3883 9.65146 27.198 9.62012 27.0059 9.62012C26.8138 9.62012 26.6236 9.65146 26.4461 9.71235C26.2687 9.77324 26.1075 9.86248 25.9718 9.97496L13.5354 20.3175L12.5104 23.925C12.472 24.0806 12.4712 24.241 12.5079 24.3969C12.5446 24.5528 12.6181 24.7012 12.7243 24.8335C12.8304 24.9659 12.9672 25.0797 13.1266 25.1683C13.286 25.2569 13.465 25.3186 13.6533 25.35C13.7468 25.3577 13.841 25.3577 13.9345 25.35C14.0457 25.3649 14.159 25.3649 14.2702 25.35L18.6696 24.5475L31.097 14.25C31.2327 14.1384 31.3405 14.0058 31.414 13.8597C31.4875 13.7136 31.5254 13.5569 31.5254 13.3987C31.5254 13.2405 31.4875 13.0838 31.414 12.9377C31.3405 12.7916 31.2327 12.659 31.097 12.5475V12.5025ZM17.7444 23.1825L14.4244 23.79L15.2317 21.0675L24.5567 13.275L27.1148 15.39L17.7444 23.1825ZM28.1398 14.5425L25.5818 12.4275L27.0241 11.25L29.6002 13.38L28.1398 14.5425Z"
                  fill="white"
                />
              </svg>
              <p className="text-heading font-semibold text-p1 absolute -bottom-8 -left-2 w-20">
                Book Data
              </p>
            </div>

            <div
              style={{
                background:
                  currentStep === 4
                    ? "linear-gradient(90deg, #702963, #fff)"
                    : currentStep > 4
                    ? "#702963"
                    : "#c2c2bd"
              }}
              className="w-progress-chart-1 h-1 "
            ></div>
            <div
              className={`relative rounded-full w-12 h-12 ${
                currentStep > 4 ? "bg-primary-dark" : "bg-[#c2c2bd]"
              } border-2 border-solid border-primary-light flex justify-center items-center`}
            >
              <svg
                width="27"
                height="22"
                viewBox="0 0 27 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1608_8310)">
                  <path
                    fillRule="evenodd"
                    clip-rule="evenodd"
                    d="M0.574219 11C0.574219 8.08262 1.95042 5.28473 4.40008 3.22183C6.84973 1.15893 10.1722 0 13.6365 0C17.1009 0 20.4233 1.15893 22.873 3.22183C25.3226 5.28473 26.6988 8.08262 26.6988 11C26.6988 13.9174 25.3226 16.7153 22.873 18.7782C20.4233 20.8411 17.1009 22 13.6365 22C10.1722 22 6.84973 20.8411 4.40008 18.7782C1.95042 16.7153 0.574219 13.9174 0.574219 11H0.574219ZM12.8911 15.708L20.4115 7.79093L19.053 6.87573L12.6403 13.6239L8.0981 10.4368L6.98345 11.5632L12.8911 15.7095V15.708Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1608_8310">
                    <rect
                      width="26.1246"
                      height="22"
                      fill="white"
                      transform="translate(0.574219)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <p className="text-heading font-semibold text-p1 absolute -bottom-8 -left-2">
                Overview
              </p>
            </div>
          </div>

          {renderedStep}

          <button
            onClick={() => {
              setModals((prevState) => ({
                ...prevState,
                uploadByBook: false
              }));
              setPaid(false);
              setCurrentStep(1);
            }}
            className="absolute top-8 right-8"
          >
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                fill="black"
                fillOpacity="0.53"
              />
            </svg>
          </button>
        </div>
      </DialogBox>
      {modals.addendums && (
        <Addendums
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          modals={modals}
          setModals={setModals}
          parentId={parentId}
        />
      )}

      <DialogBox show={newBookAdded}>
        <PopUp
          height={true}
          style={{ bottom: "0px" }}
          onClick={() => {
            setNewBookAdded(false);
          }}
          onClose={() => {
            setNewBookAdded(false);
          }}
          button="Done"
          title="New Book Added Successfully!"
          main="Congratulations! Your Ebook has been created, please visit the Catalogue Book Page to view it."
          body="You will be able to create AccessIDs for the books &#38; then distribute then same by creating OrderIDs"
        />
      </DialogBox>
      <DialogBox show={modals.waitPop}>
        <PopUp
          height={true}
          style={{ bottom: "0px" }}
          onClick={() => {
            setModals((prev) => ({ ...prev, waitPop: true }));
          }}
          onClose={() => {
            setModals((prev) => ({ ...prev, waitPop: true }));
          }}
          button="Close"
          title="Confirmation "
          main="Your book is under going conversion "
          body="Your book is under going conversion it take 10min to 1 hours wait"
        />
      </DialogBox>
      <DialogBox show={modals.draftDelete}>
        <PopUp
          height={true}
          style={{ bottom: "0px" }}
          onClick={() => {
            deletedraft();
          }}
          onClose={() => {
            setModals((prev) => ({ ...prev, draftDelete: false }));
          }}
          button="Confirm"
          title="Confirmation "
          main="Are sure you want to Delete this draft"
          body="Click on confirm button to continue"
        />
      </DialogBox>
      <DialogBox show={modals.paymentSuccessful}>
        <PopUp
          height={true}
          style={{ bottom: "0px" }}
          onClick={() => {
            setModals((prev) => ({ ...prev, paymentSuccessful: false }));
          }}
          onClose={() => {
            setModals((prev) => ({ ...prev, paymentSuccessful: false }));
          }}
          button="Close"
          title="Payment Successfully"
          main="Your book is under going conversion"
          body="We will notify you once the Book is Converted."
        />
      </DialogBox>
      <DialogBox show={cancelNewBook}>
        <div className="bottom-0 bg-primary-white flex flex-col gap-10 justify-between relative w-full h-[100%] lg:w-pop-up p-8">
          <h4 className="text-h4 text-tertiary-dark font-bold">
            Are you sure you want to Cancel the Process?
          </h4>
          <div className="flex gap-2 lg:justify-center text-center lg:text-right">
            <BtnSmallWhite
              onClick={() => {
                setCancelNewBook(false);
                setShowUploadBook(true);
              }}
            >
              Cancel
            </BtnSmallWhite>

            <button
              onClick={() => {
                setCancelNewBook(false);
                setShowUploadBook(false);
                setCurrentStep(1);
                setModals((prev) => ({ ...prev, uploadByBook: false }));
              }}
              className="w-full max-w-[372px] lg:w-[150px] h-[56px] bg-primary-dark text-primary-white text-mobile-h5 lg:text-h5"
            >
              Confirm
            </button>
          </div>
          <button
            onClick={() => {
              setCancelNewBook(false);
              setShowUploadBook(true);
            }}
            className="absolute top-8 right-8"
          >
            <svg
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                fill="black"
                fillOpacity="0.53"
              />
            </svg>
          </button>
        </div>
      </DialogBox>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
      />

      {/* <Loader show={true} /> */}
    </Page>
  );
}
